<template>
    <div>
        <div class="line-gap">
            <!--
            <select-check-form title='타이틀' :select-data='["전체", "서브1"]' :select-value='["all","sub-1"]'></select-check-form>
            -->
            <select-check-form
                :select-data="['전체', '서브1']"
                :select-value="['all', 'sub-1']"
                title="타이틀"
            ></select-check-form>
            <div v-click-outside="outsideClick" :class="{ on: selectOpen }" class="ui-select">
                <button @click="selectOpen = !selectOpen"><span class="txt">타이틀</span></button>
                <ul>
                    <li>
                        <div class="com-check">
                            <input id="select-check-1" name="select-check-1" type="checkbox" />
                            <label for="select-check-1">전체</label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="line-gap">
            <select-form :select-data="['선택']"></select-form>
        </div>

        <div class="line-gap">
            <div class="com-calendar-wrap">
                <single-calendar></single-calendar>
                <div class="com-dash"><span class="dash">~</span></div>
                <single-calendar></single-calendar>
            </div>
        </div>

        <div class="line-gap">
            <div class="com-radio">
                <input id="radio-1-1" checked name="radio-1" type="radio" />
                <label for="radio-1-1">본점</label>
            </div>
        </div>

        <div class="line-gap">
            <div class="com-radio check">
                <input id="radio-2-1" checked name="radio-2" type="radio" />
                <label for="radio-2-1">본점</label>
            </div>
        </div>

        <div class="line-gap">
            <div class="com-check">
                <input id="check-1-1" name="check-1" type="checkbox" />
                <label for="check-1-1">보증금</label>
            </div>
        </div>

        <div class="line-gap">
            <div class="com-design-check">
                <input id="check-2" name="check-2" type="checkbox" />
                <label for="check-2"></label>
            </div>
        </div>

        <div class="line-gap">
            <div class="input-del">
                <input type="text" />
                <button class="del"></button>
            </div>
        </div>

        <div class="line-gap">
            <div class="member-group-content">
                <span class="title">그룹명</span>
                <div class="check-area">
                    <div class="check-btn">
                        <div class="com-radio-txt">
                            <input id="check-1-1" checked name="check-1" type="radio" />
                            <label for="check-1-1">소속없음</label>
                        </div>
                        <div class="com-radio-txt">
                            <input id="check-1-2" name="check-1" type="radio" />
                            <label for="check-1-2">그룹레슨팀</label>
                        </div>
                        <div class="com-radio-txt">
                            <input id="check-1-3" name="check-1" type="radio" />
                            <label for="check-1-3">FC팀</label>
                        </div>
                        <button class="com-setting-btn"><span class="blind">설정</span></button>
                    </div>
                </div>
            </div>
        </div>

        <div class="line-gap">
            <div class="com-btn-area">
                <div class="right-box">
                    <a class="com-btn" href="#" @click="pop = 1">직원관리 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 2">체인점 등록 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 3">카테고리 설정 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 31">카테고리 이동 설정 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 4">센터 검색 결과 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 5">회원 검색 결과 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 6">환불 신청 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 7">마일리지 등록 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 8">상담내용 수정 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 9">이미지 미리보기 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 10">기간연장 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 11">대여내역 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 12">기간연장 일괄등록 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 13">발신자 추가 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 14">체인점 등록 레이어 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 15">스케줄표 시간설정 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 16">정보확인 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 17">스케줄 예약 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 18">출결승인 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 19">휴강하기 확인 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 20">휴강하기 완료 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 21">그룹 일괄 예약</a>
                    <a class="com-btn" href="#" @click="pop = 22">기간연장 팝업</a>
                    <a class="com-btn" href="#" @click="pop = 23">스케줄 예약 심플 팝업</a>
                </div>
            </div>
        </div>

        <div class="line-gap">
            <div class="com-btn-area">
                <div class="left-box">
                    <button class="com-btn excel">com-btn excel</button>
                </div>
                <div class="right-box">
                    <a class="com-btn deep-blue" href="#">com-btn</a>
                    <a class="com-btn" href="#">com-btn</a>
                    <a class="com-btn red" href="#">com-btn</a>
                    <a class="com-btn gray" href="#">com-btn</a>
                    <a class="com-btn white" href="#">com-btn white</a>
                    <a class="com-btn blue" href="#">com-btn blue</a>
                </div>
            </div>
        </div>

        <div class="top-title-content">
            <span class="title">권한설정</span>
            <span class="txt">핏투데이케어에서 센터 admin에 제공하는 메뉴별, 권한별 기본 권한을 설정합니다.</span>
        </div>

        <p class="sub-title">마일리지 설정</p>

        <div class="sub-title-content">
            <span class="title">기본설정</span>
            <p class="info-txt">패키지 이용권의 이름과 금액 등 기본설정을 진행합니다.</p>
        </div>

        <div class="com-table-top">
            <span class="title">센터등록</span>
        </div>

        <div class="com-table-top">
            <span class="title">센터등록</span>
            <table class="com-table">
                <colgroup>
                    <col style="width: 160px" />
                    <col style="width: 110px" />
                    <col style="width: 140px" />
                    <col style="width: 140px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 425px" />
                    <col style="width: 110px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>최신상담일자</th>
                        <th>회원명</th>
                        <th>연락처</th>
                        <th>상담유형</th>
                        <th>상담경로</th>
                        <th>유입경로</th>
                        <th>회원구분</th>
                        <th>상담내용</th>
                        <th>상담자</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>2019-12-23</td>
                        <td>
                            <a class="link" href="#">홍길동</a>
                        </td>
                        <td>010-9999-9999</td>
                        <td>등록</td>
                        <td>전화</td>
                        <td>전단지</td>
                        <td>비회원</td>
                        <td>
                            <a class="link line-2" href="#">
                                필라테스 3개월 다니다가 새로 옮기고 싶어서 문의 드렸다고 하는데 고민중이라고 합니다.
                                일단 오셔서 상담하도록 유도했습니다. 필라테스 3개월 다니다가 새로 옮기고 싶어서 문의
                                드렸다고 하는데 고민중이라고 합니다. 일단 오셔서 상담하도록 유도했습니다.
                            </a>
                        </td>
                        <td>조인성</td>
                    </tr>
                    <tr>
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button class="com-btn excel">엑셀 다운로드</button>
                <select-form
                    :select-data="['10줄보기', '20줄보기', '50줄보기', '100줄보기']"
                    class="float-right"
                    @update:set="(val) => (value = val)"
                ></select-form>
            </div>
        </div>

        <div class="com-author-table">
            <div class="com-btn-area">
                <div class="left-box">
                    <span class="txt red">최대 10개까지 등록 가능합니다.</span>
                </div>
                <div class="right-box">
                    <a class="com-btn white" href="/madmin/author/edit">수정</a>
                    <a class="com-btn" href="#">+ 추가</a>
                </div>
            </div>
            <table class="grade-table">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="width: 350px" />
                    <col style="width: 160px" />
                    <col style="width: 210px" />
                </colgroup>
                <thead>
                    <tr class="top-header">
                        <th></th>
                        <th>직급명</th>
                        <th>권한구성</th>
                        <th></th>
                    </tr>
                    <tr class="header">
                        <th>최고권한</th>
                        <th class="left">대표</th>
                        <th><a class="link" href="/madmin/author/detail">상세보기 &gt;</a></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <button class="down"></button>
                            <button class="up"></button>
                        </td>
                        <td class="left">대표관리자</td>
                        <td><a class="link" href="/madmin/author/detail">상세보기 &gt;</a></td>
                        <td>
                            <button class="com-btn blue">권한복제</button>
                            <button class="com-btn">삭제</button>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <button class="down"></button>
                            <button class="up"></button>
                        </td>
                        <td class="left">중간관리자</td>
                        <td><a class="link" href="/madmin/author/detail">상세보기 &gt;</a></td>
                        <td>
                            <button class="com-btn blue">권한복제</button>
                            <button class="com-btn">삭제</button>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <button class="down"></button>
                            <button class="up"></button>
                        </td>
                        <td class="left">강사</td>
                        <td><a class="link" href="/madmin/author/detail">상세보기 &gt;</a></td>
                        <td>
                            <button class="com-btn blue">권한복제</button>
                            <button class="com-btn">삭제</button>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td>기본권한</td>
                        <td class="left">기본권한</td>
                        <td><a class="link" href="/madmin/author/detail">상세보기 &gt;</a></td>
                        <td></td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <p class="sub-title">메뉴별 세부권한 수정하기</p>

        <p class="sub-title small">메뉴별 세부권한 수정하기</p>

        <div class="com-tab">
            <button class="on">회원</button>
            <button>수업</button>
        </div>

        <p class="sub-title small">
            <strong>회원 예약시간 제한설정</strong>
            센터에서 진행하는 개인, 듀엣, OT 의 수업시작시간과 수업시간의 단위에 대한 시간표현을 설정합니다.
        </p>

        <div class="com-table-wrap">
            <div class="com-btn-area">
                <div class="right-box">
                    <a class="com-btn white" href="#">수정</a>
                    <a class="com-btn" href="#">+ 추가</a>
                </div>
            </div>
            <table class="com-table no-border">
                <colgroup>
                    <col style="width: 100px" />
                    <col style="width: 120px" />
                    <col style="width: 400px" />
                    <col style="width: 854px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <div class="com-check th">
                                <input id="check-all" name="check-all" type="checkbox" />
                                <label for="check-all">사용여부</label>
                            </div>
                        </th>
                        <th>번호</th>
                        <th>권한명</th>
                        <th>설명</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-1" name="check-1" type="checkbox" />
                                <label for="check-1"></label>
                            </div>
                        </td>
                        <td>1</td>
                        <td class="left">회원등록</td>
                        <td>설명글</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-2" name="check-2" type="checkbox" />
                                <label for="check-2"></label>
                            </div>
                        </td>
                        <td>2</td>
                        <td class="left">회원삭제</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-3" name="check-3" type="checkbox" />
                                <label for="check-3"></label>
                            </div>
                        </td>
                        <td>3</td>
                        <td class="left">회원정보 수정</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-4" checked name="check-4" type="checkbox" />
                                <label for="check-4"></label>
                            </div>
                        </td>
                        <td>4</td>
                        <td class="left">마일리지 - 수기등록</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-5" name="check-5" type="checkbox" />
                                <label for="check-5"></label>
                            </div>
                        </td>
                        <td>5</td>
                        <td class="left">상담내역 - 등록, 수정, 삭제</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-6" name="check-6" type="checkbox" />
                                <label for="check-6"></label>
                            </div>
                        </td>
                        <td>6</td>
                        <td class="left">상담유형 설정</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-7" name="check-7" type="checkbox" />
                                <label for="check-7"></label>
                            </div>
                        </td>
                        <td>7</td>
                        <td class="left">기간연장 일괄등록</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-8" name="check-8" type="checkbox" />
                                <label for="check-8"></label>
                            </div>
                        </td>
                        <td>8</td>
                        <td class="left">락커대여 - 등록, 수정, 삭제</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-wrap">
            <table class="com-table no-border">
                <colgroup>
                    <col style="width: 100px" />
                    <col style="width: 120px" />
                    <col style="width: 400px" />
                    <col style="width: 854px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <div class="com-check th">
                                <input id="check-all" name="check-all" type="checkbox" />
                                <label for="check-all">사용여부</label>
                            </div>
                        </th>
                        <th>번호</th>
                        <th>권한명</th>
                        <th>설명</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-1" name="check-1" type="checkbox" />
                                <label for="check-1"></label>
                            </div>
                        </td>
                        <td>1</td>
                        <td class="left">
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                        <td>
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-2" name="check-2" type="checkbox" />
                                <label for="check-2"></label>
                            </div>
                        </td>
                        <td>2</td>
                        <td class="left">
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                        <td>
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-3" name="check-3" type="checkbox" />
                                <label for="check-3"></label>
                            </div>
                        </td>
                        <td>3</td>
                        <td class="left">
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                        <td>
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-4" checked name="check-4" type="checkbox" />
                                <label for="check-4"></label>
                            </div>
                        </td>
                        <td>4</td>
                        <td class="left">
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                        <td>
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-5" name="check-5" type="checkbox" />
                                <label for="check-5"></label>
                            </div>
                        </td>
                        <td>5</td>
                        <td class="left">
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                        <td>
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-6" name="check-6" type="checkbox" />
                                <label for="check-6"></label>
                            </div>
                        </td>
                        <td>6</td>
                        <td class="left">
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                        <td>
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-7" name="check-7" type="checkbox" />
                                <label for="check-7"></label>
                            </div>
                        </td>
                        <td>7</td>
                        <td class="left">
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                        <td>
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="com-design-check">
                                <input id="check-8" name="check-8" type="checkbox" />
                                <label for="check-8"></label>
                            </div>
                        </td>
                        <td>8</td>
                        <td class="left">
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                        <td>
                            <div class="input-del">
                                <input type="text" />
                                <button class="del"></button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <a class="com-btn blue" href="#">목록보기</a>
                </div>
            </div>
            <div class="top-select">
                <select-form :select-data="['선택']" class="w420"></select-form>
            </div>
            <table class="com-table td-left">
                <colgroup>
                    <col style="width: 160px" />
                    <col style="width: 340px" />
                    <col style="width: 160px" />
                    <col style="width: 270px" />
                    <col style="width: 160px" />
                    <col style="width: 270px" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>이용권명</th>
                        <td>[그룹] 필라테스 24회</td>
                        <th>회원명</th>
                        <td>김미미</td>
                        <th>센터명</th>
                        <td>핏투데이케어 - 잠실점</td>
                    </tr>
                    <tr>
                        <th>유효기간</th>
                        <td>
                            <span class="txt">2019.09.29 - 2020.01.29</span>
                            <button class="com-btn">기간연장</button>
                            <button class="com-btn blue">내역</button>
                        </td>
                        <th>강사명</th>
                        <td>김윤경</td>
                        <th>수업현황</th>
                        <td>
                            회당 1시간, 2/10 회
                            <strong>
                                (출석
                                <span class="red">9</span>
                                / 결석
                                <span class="red">1</span>
                                )
                            </strong>
                        </td>
                    </tr>
                    <tr>
                        <th>비고사항</th>
                        <td colspan="5"></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-tab">
            <button class="on">스케줄 현황</button>
            <button>히스토리</button>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <button class="com-btn excel">엑셀 다운로드</button>
                </div>
                <div class="right-box">
                    <a class="com-btn" href="#">그룹 달력보기</a>
                    <a class="com-btn blue" href="#">등록</a>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 60px" />
                    <col style="width: 150px" />
                    <col style="width: 170px" />
                    <col style="width: 150px" />
                    <col style="width: 150px" />
                    <col style="width: 340px" />
                    <col style="width: 110px" />
                    <col style="width: 150px" />
                    <col style="width: 130px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>회차</button>
                        </th>
                        <th>
                            <button>강사명</button>
                        </th>
                        <th>
                            <button>수업일자</button>
                        </th>
                        <th>
                            <button>시작시간</button>
                        </th>
                        <th>수업시간</th>
                        <th>룸 선택</th>
                        <th>관리</th>
                        <th>출결현황</th>
                        <th>정산현황</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>김윤경</td>
                        <td>2020-01-01</td>
                        <td>09:00</td>
                        <td>1시간</td>
                        <td class="left">
                            <div class="info-line">
                                <span>
                                    <span class="time">09:00 ~ 09:30</span>
                                    라포머룸
                                </span>
                                <span>
                                    <span class="time">09:00 ~ 09:30</span>
                                    라포머룸
                                </span>
                            </div>
                        </td>
                        <td></td>
                        <td>
                            <div class="info-line">
                                <span>
                                    <span>출석</span>
                                    (08.20 11:51)
                                </span>
                                <span>
                                    <button class="com-btn gray">출결취소</button>
                                </span>
                            </div>
                        </td>
                        <td>
                            <div class="info-line">
                                <span>완료 (08.20 11:58)</span>
                                <span>
                                    <button class="com-btn gray">정산취소</button>
                                </span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>김윤경</td>
                        <td>2020-01-01</td>
                        <td>09:00</td>
                        <td>1시간</td>
                        <td class="left">
                            <div class="info-line">
                                <span>
                                    <span class="time">09:00 ~ 09:30</span>
                                    라포머룸
                                </span>
                                <span>
                                    <span class="time">09:00 ~ 09:30</span>
                                    라포머룸
                                </span>
                            </div>
                        </td>
                        <td></td>
                        <td>
                            <div class="info-line">
                                <span>
                                    <span class="red">결석</span>
                                    (08.20 11:51)
                                </span>
                                <span>
                                    <button class="com-btn gray">출결취소</button>
                                </span>
                            </div>
                        </td>
                        <td>
                            <div class="info-line">
                                <span>완료 (08.20 11:58)</span>
                                <span>
                                    <button class="com-btn">정산승인</button>
                                </span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>김윤경</td>
                        <td>2020-01-01</td>
                        <td>09:00</td>
                        <td>1시간</td>
                        <td class="left">
                            <div class="info-line">
                                <span>
                                    <span class="time">09:00 ~ 09:30</span>
                                    라포머룸
                                </span>
                                <span>
                                    <span class="time">09:00 ~ 09:30</span>
                                    라포머룸
                                </span>
                            </div>
                        </td>
                        <td>
                            <button class="com-btn">변경</button>
                            <button class="com-btn red">취소</button>
                        </td>
                        <td>
                            <div class="info-line">
                                <span>
                                    <button class="com-btn">출결승인</button>
                                </span>
                            </div>
                        </td>
                        <td>미정산</td>
                    </tr>
                    <tr>
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="['10줄보기', '20줄보기', '50줄보기', '100줄보기']"
                    class="float-right"
                ></select-form>
            </div>
            <b-pagination
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
            ></b-pagination>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <span class="tit">이용권 결제 내역</span>
                    <span class="sub-tit red">소멸예정 : 1,000원</span>
                    <button class="com-btn excel">엑셀 다운로드</button>
                </div>
                <div class="right-box">
                    <a class="com-btn red" href="#">삭제</a>
                    <a class="com-btn blue" href="/madmin/member/edit">등록</a>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 80px" />
                    <col style="width: 130px" />
                    <col style="width: 170px" />
                    <col style="width: 150px" />
                    <col style="width: 140px" />
                    <col style="width: 175px" />
                    <col style="width: 140px" />
                    <col style="width: 150px" />
                    <col style="width: 150px" />
                    <col style="width: 150px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <div class="com-check">
                                <input id="check-1-1" name="check-1" type="checkbox" />
                                <label for="check-1-1"></label>
                            </div>
                        </th>
                        <th>
                            <button>회원명</button>
                        </th>
                        <th>연락처</th>
                        <th>생년월일</th>
                        <th>유효여부</th>
                        <th>사용중인 이용권</th>
                        <th>
                            <button>이용권등록수</button>
                        </th>
                        <th>
                            <button>마일리지</button>
                        </th>
                        <th>
                            <button>등록일</button>
                        </th>
                        <th>센터명</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="com-check">
                                <input id="check-2-1" name="check-2" type="checkbox" />
                                <label for="check-2-1"></label>
                            </div>
                        </td>
                        <td><a class="link" href="#">홍길동</a></td>
                        <td>010-9999-9999</td>
                        <td>1985-01-01</td>
                        <td>유효회원</td>
                        <td>
                            <span class="ico type-1">[개인]</span>
                            <span class="ico type-2">[그룹]</span>
                            <span class="ico type-3">[패키지]</span>
                            <span class="ico type-4">[회원권]</span>
                            <span class="ico type-5">[듀엣]</span>
                            <span class="ico type-6">[OT]</span>
                        </td>
                        <td>3</td>
                        <td>1,023</td>
                        <td>2019-07-07</td>
                        <td>핏투데이케어-본점</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button class="com-btn excel">엑셀 다운로드</button>
                <select-form
                    :select-data="['10줄보기', '20줄보기', '50줄보기', '100줄보기']"
                    class="float-right"
                    @update:set="(val) => (value = val)"
                ></select-form>
            </div>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <button class="com-setting-btn" @click="categoryPop = true"></button>
                </div>
                <div class="right-box">
                    <a class="com-btn" href="#">목록</a>
                    <a class="com-btn blue" href="#">등록</a>
                </div>
            </div>
            <table class="com-table edit">
                <colgroup>
                    <col style="width: 150px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>카테고리</th>
                        <td class="no-padding">
                            <select-form
                                :select-data="['카테고리를 선택하세요.', '공지사항', '업데이트', '이벤트']"
                                :select-value="[null, 'test-1-1', 'test-1-2', 'test-1-3', 'test-1-4']"
                                class="full"
                            ></select-form>
                        </td>
                    </tr>
                    <tr>
                        <th>노출대상</th>
                        <td class="no-padding">
                            <select-form
                                :select-data="[
                                    '노출대상을 선택하세요.',
                                    '전체 <small>(관리자 PC, 관리자 APP, 회원 APP 공지사항에 노출됩니다.)</small>',
                                    '관리자 <small>(관리자 PC, 관리자 APP 공지사항에 노출됩니다.)</small>',
                                    '회원 <small>(회원 APP 공지사항에 노출됩니다.)</small>',
                                ]"
                                :select-value="[null, 'test-2-1', 'test-2-2', 'test-2-3']"
                                class="full"
                            ></select-form>
                        </td>
                    </tr>
                    <tr>
                        <th>제목</th>
                        <td>
                            <input class="w100p" type="text" />
                        </td>
                    </tr>
                    <tr>
                        <th>내용</th>
                        <td>
                            <div style="height: 600px">에디트 영역</div>
                        </td>
                    </tr>
                    <tr>
                        <th>파일 첨부</th>
                        <td class="no-padding">
                            <div class="file-box">
                                <input class="design-input" readonly type="text" value="파일명.jpg" />
                                <b-form-file id="file1" accept=".jpg, .png, .gif" plain></b-form-file>
                                <label for="file1">찾아보기</label>
                            </div>
                            <p class="file-info">
                                ※ 이미지는 660px*660px 정사각형 사이즈와 최대 100MB 용량으로 최적화되어 있습니다.
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="table-bottom-check">
                <div class="com-check">
                    <input id="check-1-1" name="check-1" type="checkbox" />
                    <label for="check-1-1">이 글을 상단에 고정합니다.</label>
                </div>
            </div>
            <div class="com-btn-area">
                <div class="right-box">
                    <a class="com-btn" href="#">목록</a>
                    <a class="com-btn blue" href="#">등록</a>
                </div>
            </div>
        </div>

        <div class="top-title-content">
            <span class="title">센터관리</span>
            <span class="txt">센터 기본정보를 등록하고, 관리한다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="right">
                    <select-form :select-data="['선택']"></select-form>
                    <select-form :select-data="['선택']"></select-form>
                    <div v-click-outside="outsideClick" :class="{ on: selectOpen }" class="ui-select">
                        <button @click="selectOpen = !selectOpen"><span class="txt">강사선택</span></button>
                        <ul>
                            <li>
                                <div class="com-check">
                                    <input id="select-check-1" name="select-check-1" type="checkbox" />
                                    <label for="select-check-1">전체선택</label>
                                </div>
                            </li>
                            <li>
                                <div class="com-check">
                                    <input id="select-check-2" name="select-check-1" type="checkbox" />
                                    <label for="select-check-2">송혜교</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <button class="com-search-reset"></button>
                </div>
            </div>
            <div class="line">
                <div class="com-calendar-wrap">
                    <button class="prev-day"></button>
                    <single-calendar></single-calendar>
                    <button class="next-day"></button>
                </div>
                <div class="right">
                    <button class="top-link-btn on">일일스케줄</button>
                    <button class="top-link-btn">그룹 주간표</button>
                    <button class="top-link-btn">강사 주간표</button>
                    <button class="top-link-btn green">룸 스케줄표</button>
                    <button class="com-setting-btn"><span class="blind">설정</span></button>
                </div>
            </div>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="right">
                    <select-form :select-data="['선택']"></select-form>
                    <select-form :select-data="['선택']"></select-form>
                    <div v-click-outside="outsideClick" :class="{ on: selectOpen }" class="ui-select">
                        <button @click="selectOpen = !selectOpen"><span class="txt">강사선택</span></button>
                        <ul>
                            <li>
                                <div class="com-check">
                                    <input id="select-check-1" name="select-check-1" type="checkbox" />
                                    <label for="select-check-1">전체선택</label>
                                </div>
                            </li>
                            <li>
                                <div class="com-check">
                                    <input id="select-check-2" name="select-check-1" type="checkbox" />
                                    <label for="select-check-2">송혜교</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <button class="com-search-reset"></button>
                </div>
            </div>
            <div class="line">
                <div class="com-calendar-wrap">
                    <button class="prev-day"></button>
                    <single-calendar></single-calendar>
                    <button class="next-day"></button>
                </div>
                <div class="right">
                    <button class="top-link-btn on">일일스케줄</button>
                    <button class="top-link-btn">그룹 주간표</button>
                    <button class="top-link-btn">강사 주간표</button>
                    <button class="top-link-btn">룸 스케줄표</button>
                    <button class="top-link-btn green" @click="reservationPop = true">신규예약</button>
                    <button class="com-setting-btn" @click="timePop = true"><span class="blind">설정</span></button>
                </div>
            </div>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar></single-calendar>
                </div>
                <select-form :select-data="['선택']"></select-form>
                <div class="com-search-input">
                    <input placeholder="이름 입력" type="text" />
                    <button class="search-btn">검색</button>
                </div>
            </div>
            <div class="line">
                <select-form :select-data="['선택']"></select-form>
                <select-form :select-data="['선택']"></select-form>
                <select-form :select-data="['선택']"></select-form>
                <button class="com-search-reset"></button>
            </div>
        </div>
        <div class="com-search-content">
            <div class="line">
                <div class="com-radio">
                    <input id="radio-day-1" checked name="radio-day" type="radio" />
                    <label for="radio-day-1">예약일자</label>
                </div>
                <div class="com-radio">
                    <input id="radio-day-2" name="radio-day" type="radio" />
                    <label for="radio-day-2">수업일자</label>
                </div>
                <div class="com-calendar-wrap">
                    <single-calendar></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar></single-calendar>
                </div>
                <select-form :select-data="['선택']" @update:set="(val) => (setValue = val)"></select-form>
            </div>
            <div class="line">
                <select-form :select-data="['선택']"></select-form>
                <select-form :select-data="['선택']"></select-form>
                <select-form :select-data="['선택']"></select-form>
                <button class="com-search-reset"></button>
            </div>
        </div>
        <div class="com-btn-area">
            <div class="left-box">
                <button class="com-btn excel">엑셀 다운로드</button>
            </div>
            <div class="right-box">
                <a class="com-btn blue" href="#">센터등록</a>
            </div>
        </div>
        <div class="com-table-content">
            <!--
            <b-table :items="items" :fields="fields" :per-page="perPage" :current-page="currentPage" class="com-table"
                id="my-table">
                <template v-slot:table-colgroup>
                    <col style="width:140px">
                    <col style="width:220px">
                    <col style="width:140px">
                    <col style="width:126px">
                    <col style="width:100px">
                    <col style="width:92px">
                    <col style="width:160px">
                    <col style="width:160px">
                    <col style="width:300px">
                    <col style="width:100px">
                </template>
                <template v-slot:cell(th2)="data">
                    <a href="#" class="link">{{ data.value }}</a>
                </template>
                <template v-slot:cell(th3)="data">
                    <button class="blue" @click="accountPop = true">{{ data.value }}</button>
                </template>
            </b-table>
            -->
            <table class="com-table">
                <colgroup>
                    <col style="width: 140px" />
                    <col style="width: 220px" />
                    <col style="width: 140px" />
                    <col style="width: 126px" />
                    <col style="width: 100px" />
                    <col style="width: 92px" />
                    <col style="width: 160px" />
                    <col style="width: 160px" />
                    <col style="width: 300px" />
                    <col style="width: 100px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>계약일</button>
                        </th>
                        <th>센터명</th>
                        <th>접속</th>
                        <th>업종</th>
                        <th>센터구분</th>
                        <th>담당자명</th>
                        <th>담당자 연락처</th>
                        <th>센터 전화번호</th>
                        <th>센터 주소</th>
                        <th>계약상태</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>2019-12-25</td>
                        <td><a class="link" href="#">샤샤필라테스</a></td>
                        <td>
                            <button class="com-btn small blue" @click="accountPop = true">직원보기</button>
                        </td>
                        <td>필라테스</td>
                        <td>본점</td>
                        <td>김윤경</td>
                        <td>010-1234-4567</td>
                        <td>02-222-2222</td>
                        <td>서울시 송파구 석촌동 1-2</td>
                        <td>유효</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="['10줄보기', '20줄보기', '50줄보기', '100줄보기']"
                    class="float-right"
                ></select-form>
            </div>
        </div>
        <b-pagination
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
        ></b-pagination>

        <div class="com-table-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 140px" />
                    <col style="width: 220px" />
                    <col style="width: 140px" />
                    <col style="width: 100px" />
                    <col style="width: 240px" />
                    <col style="width: 240px" />
                    <col style="width: 120px" />
                    <col style="width: 220px" />
                    <col style="width: 120px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>계약일</button>
                        </th>
                        <th>
                            <button>센터명</button>
                        </th>
                        <th>
                            <button>계약유형</button>
                        </th>
                        <th>
                            <button>업종</button>
                        </th>
                        <th>
                            <button>프로그램명</button>
                        </th>
                        <th>
                            <button>프로그램 사용기간</button>
                        </th>
                        <th>
                            <button>문자</button>
                        </th>
                        <th>
                            <button>문자 사용기간</button>
                        </th>
                        <th>
                            <button>계약상태</button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>2019-12-25</td>
                        <td>
                            <a class="link" href="/madmin/business/contract/detail">
                                샤샤필라테스
                                <span class="com-btn-small black">체인</span>
                            </a>
                        </td>
                        <td>월 결제</td>
                        <td>필라테스</td>
                        <td>베이직 1개월 (월정액)</td>
                        <td>
                            <span class="info-line">
                                <span>2020-01-01 ~ 2020-01-31</span>
                                <span class="expire red">만료 2일 전</span>
                            </span>
                        </td>
                        <td>1개월</td>
                        <td>
                            <span class="info-line">
                                <span>2020-01-01 ~ 2020-01-31</span>
                                <span class="expire red">만료 2일 전</span>
                            </span>
                        </td>
                        <td>유효</td>
                    </tr>
                    <tr>
                        <td>2019-12-25</td>
                        <td><a class="link" href="#">샤샤필라테스</a></td>
                        <td>월 결제</td>
                        <td>필라테스</td>
                        <td>베이직 1개월 (월정액)</td>
                        <td>
                            <a class="com-btn-small blue" href="#">연장</a>
                            <a class="com-btn-small red" href="#">환불</a>
                        </td>
                        <td>1개월</td>
                        <td>
                            <span class="info-line">
                                <span>2020-01-01 ~ 2020-01-31</span>
                                <span class="black">690일 남음</span>
                            </span>
                        </td>
                        <td><span class="red">종료</span></td>
                    </tr>
                    <tr>
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="['10줄보기', '20줄보기', '50줄보기', '100줄보기']"
                    class="float-right"
                    @update:set="(val) => (value = val)"
                ></select-form>
            </div>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <span class="tit">이용권 결제 내역</span>
                </div>
                <div class="right-box">
                    <a class="com-btn blue" href="#">이용권 결제</a>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 430px" />
                    <col style="width: 245px" />
                    <col style="width: 285px" />
                    <col style="width: 155px" />
                    <col style="width: 155px" />
                    <col style="width: 155px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>이용권명</button>
                        </th>
                        <th>
                            <button>유효기간</button>
                        </th>
                        <th>이용권현황</th>
                        <th>
                            <button>담당강사</button>
                        </th>
                        <th>
                            <button>결제금액</button>
                        </th>
                        <th>
                            <button>등록일</button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="left"><a class="link" href="#">[개인] 필라테스 10회 PL</a></td>
                        <td>
                            <span class="info-line">
                                <span>2020-01-01 ~ 2020-01-31</span>
                                <span class="under">154일 남음</span>
                            </span>
                        </td>
                        <td>
                            <span class="info-line">
                                <span>
                                    <span class="red">8</span>
                                    /10 회 (출석
                                    <span class="red">6</span>
                                    / 결석
                                    <span class="red">2</span>
                                    )
                                </span>
                                <span class="center">
                                    <a class="com-btn-small deep-black" href="#">스케줄 &gt;</a>
                                </span>
                            </span>
                        </td>
                        <td>김윤경</td>
                        <td>
                            <span class="info-line">
                                <span class="blue">[카드] 500,000 원</span>
                                <span class="red">[미수금] 200,000 원</span>
                            </span>
                        </td>
                        <td>2019-07-07</td>
                    </tr>
                </tbody>
            </table>
            <b-pagination
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
            ></b-pagination>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <span class="tit">락커 결제 내역</span>
                </div>
                <div class="right-box">
                    <a class="com-btn blue" href="#">락커 결제</a>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 310px" />
                    <col style="width: 150px" />
                    <col style="width: 170px" />
                    <col style="width: 330px" />
                    <col style="width: 155px" />
                    <col style="width: 155px" />
                    <col style="width: 155px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>락커명</button>
                        </th>
                        <th>락커번호</th>
                        <th>결제일자</th>
                        <th>
                            <button>유효기간</button>
                        </th>
                        <th>
                            <button>결제정보</button>
                        </th>
                        <th>
                            <button>상태</button>
                        </th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>복도락커</td>
                        <td>103</td>
                        <td>2019-09-19</td>
                        <td>
                            <span class="blue">2020-01-01 ~ 2020-01-31</span>
                        </td>
                        <td>1개월 15,000원</td>
                        <td>
                            <span class="green">사용중</span>
                        </td>
                        <td>
                            <button class="com-btn">회수</button>
                        </td>
                    </tr>
                    <tr>
                        <td>복도락커</td>
                        <td>103</td>
                        <td>2019-09-19</td>
                        <td>
                            <span class="blue">2020-01-01 ~ 2020-01-31</span>
                        </td>
                        <td>1개월 15,000원</td>
                        <td>
                            <span class="red">
                                회수완료
                                <br />
                                2020-01-01
                            </span>
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <b-pagination
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
            ></b-pagination>
        </div>

        <div class="com-table-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 480px" />
                    <col style="width: 180px" />
                    <col style="width: 140px" />
                    <col style="width: 140px" />
                    <col style="width: 140px" />
                    <col style="width: 140px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>예약일자</button>
                        </th>
                        <th>
                            <button>이용권명</button>
                        </th>
                        <th>
                            <button>수업일자</button>
                        </th>
                        <th>
                            <button>강사명</button>
                        </th>
                        <th>
                            <button>예약상태</button>
                        </th>
                        <th>
                            <button>디바이스</button>
                        </th>
                        <th>
                            <button>예약주체</button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>2019-12-23 13:00:32</td>
                        <td>
                            <span class="ico type-1">[개인]</span>
                            <span class="ico type-2">[그룹]</span>
                            <span class="ico type-3">[패키지]</span>
                            <span class="ico type-4">[회원권]</span>
                            <span class="ico type-5">[듀엣]</span>
                            <span class="ico type-6">[OT]</span>
                            필라테스 10회 PL + 개인레스 PL 10회
                        </td>
                        <td>2019-10-01(목) 19:00</td>
                        <td>김윤경</td>
                        <td><span class="red">취소</span></td>
                        <td>관리자 WEB</td>
                        <td>홍길동</td>
                    </tr>
                    <tr>
                        <td>2019-12-23 13:00:32</td>
                        <td>
                            <span class="ico type-6">[OT]</span>
                            필라테스 10회 PL + 개인레스 PL 10회
                        </td>
                        <td>2019-10-01(목) 19:00</td>
                        <td>김윤경</td>
                        <td>예약</td>
                        <td>관리자 WEB</td>
                        <td>홍길동</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="['10줄보기', '20줄보기', '50줄보기', '100줄보기']"
                    class="float-right"
                    @update:set="(val) => (value = val)"
                ></select-form>
            </div>
            <b-pagination
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
            ></b-pagination>
        </div>

        <div class="com-card-input">
            <div class="left-box">
                <div class="line">
                    <span class="tit">
                        이름
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <input class="w220" type="text" />
                    </div>
                </div>
                <div class="line">
                    <span class="tit">닉네임</span>
                    <div class="input-cnt">
                        <input class="w220" type="text" />
                    </div>
                </div>
                <div class="line">
                    <span class="tit">연락처</span>
                    <div class="input-cnt">
                        <div class="com-tel select-type">
                            <input type="text" />
                            <input type="text" />
                            <input type="text" />
                            <button class="com-btn">중복확인</button>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        권한
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <select-form
                            :select-data="['선택']"
                            class="w220"
                            @update:set="(val) => (setValue = val)"
                        ></select-form>
                    </div>
                </div>
            </div>
            <div class="right-box">
                <div class="line">
                    <span class="tit">
                        이메일
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-email">
                            <input class="first" type="text" />
                            <span class="txt">@</span>
                            <input class="last" type="text" />
                            <select-form :select-data="['선택']"></select-form>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        비밀번호
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <input class="w220" type="password" />
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        비밀번호 확인
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <input class="w220" type="password" />
                    </div>
                </div>
            </div>
        </div>

        <div class="com-table-wrap">
            <div class="com-card-input half-type">
                <div class="left-box">
                    <div class="line">
                        <span class="tit">
                            회원구분
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input id="radio-1-1" checked name="radio-1" type="radio" />
                                <label for="radio-1-1">회원</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-1-2" name="radio-1" type="radio" />
                                <label for="radio-1-2">비회원</label>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            이름
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input class="w220" type="text" />
                            <button class="com-btn">검색</button>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            연락처
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <div class="com-tel select-type">
                                <input type="text" />
                                <input type="text" />
                                <input type="text" />
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">상담자</span>
                        <div class="input-cnt">
                            <select-form :select-data="['선택']" class="w220"></select-form>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">상담일자</span>
                        <div class="input-cnt">
                            <single-calendar class="w220"></single-calendar>
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="line">
                        <span class="tit">
                            상담유형
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <select-form :select-data="['선택']" class="w220"></select-form>
                            <button class="com-setting-btn"></button>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">상담경로</span>
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input id="radio-2-1" checked name="radio-2" type="radio" />
                                <label for="radio-1-1">전화</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-2-2" name="radio-2" type="radio" />
                                <label for="radio-2-2">방문</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-2-3" name="radio-2" type="radio" />
                                <label for="radio-2-3">기타</label>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">유입경로</span>
                        <div class="input-cnt">
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input id="radio-3-1" checked name="radio-3" type="radio" />
                                    <label for="radio-3-1">전단지</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-3-2" name="radio-3" type="radio" />
                                    <label for="radio-3-2">SNS</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-3-3" name="radio-3" type="radio" />
                                    <label for="radio-3-3">블로그</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-3-4" name="radio-3" type="radio" />
                                    <label for="radio-3-4">홈페이지</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-3-5" name="radio-3" type="radio" />
                                    <label for="radio-3-5">지인소개</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">메모</span>
                        <div class="input-cnt">
                            <textarea class="com-textarea w400" placeholder="상담내용을 입력해주세요."></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="com-card-input half-type">
            <div class="left-box">
                <div class="line">
                    <span class="tit">사진</span>
                    <div class="input-cnt photo-line">
                        <span class="photo">
                            <img alt="사진" src="/img/icons/no_photo.jpg" />
                        </span>
                        <div class="info-txt">
                            <span class="txt">※ 권장 이미지 : 정사각형 사이즈, JPG, PNG 가능</span>
                            <b-form-file id="file1" accept=".jpg, .png, .gif" plain></b-form-file>
                            <label class="com-btn" for="file1">사진등록</label>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <div class="division">
                        <span class="tit">
                            이름
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input class="w220" type="text" />
                        </div>
                    </div>
                    <div class="division">
                        <span class="tit">닉네임</span>
                        <div class="input-cnt">
                            <input class="w220" type="text" />
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        연락처
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-tel select-type">
                            <input type="text" />
                            <input type="text" />
                            <input type="text" />
                            <button class="com-btn">중복확인</button>
                            <span class="error red">중복된 번호입니다.</span>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        직급/권한
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <select-form :select-data="['선택']" class="w220"></select-form>
                        <span class="sub-info">※ 상세권한 수정은 직원설정 > 권한설정에서 가능합니다.</span>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">팀</span>
                    <div class="input-cnt">
                        <select-form :select-data="['선택']" class="w400"></select-form>
                        <button class="com-btn">추가</button>
                        <!-- 추가 일시 -->
                        <div class="sub-line">
                            <input class="w400" type="text" />
                            <button class="com-btn red">삭제</button>
                        </div>
                        <div class="sub-line">
                            <input class="w400" type="text" />
                            <button class="com-btn red">삭제</button>
                        </div>
                        <!-- //추가 일시 -->
                    </div>
                </div>
                <div class="line">
                    <span class="tit">자격증 및 경력사항</span>
                    <div class="input-cnt">
                        <textarea class="com-textarea w400"></textarea>
                    </div>
                </div>
            </div>
            <div class="right-box">
                <div class="line">
                    <span class="tit">센터명</span>
                    <div class="input-cnt">
                        <select-form :select-data="['선택']" class="w220"></select-form>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        이메일
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-email">
                            <input class="first" type="text" />
                            <span class="txt">@</span>
                            <input class="last" type="text" />
                            <select-form :select-data="['선택']"></select-form>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        비밀번호
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <input class="w220" type="password" />
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        비밀번호 확인
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <input class="w220" type="password" />
                    </div>
                </div>
                <div class="line">
                    <span class="tit">생년월일</span>
                    <div class="input-cnt">
                        <single-calendar class="w220"></single-calendar>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">컬러</span>
                    <div class="input-cnt">
                        <div class="color-code">
                            <button
                                :style="{ backgroundColor: colorCodeData }"
                                class="pop-btn"
                                @click="colorPop = !colorPop"
                            ></button>
                            <!-- 클릭시 연동되는 배경칼라// -->
                            <div v-show="colorPop" class="color-select">
                                <button
                                    :class="{ on: colorCodeData == '#f44336' }"
                                    style="background-color: #f44336"
                                    @click="
                                        colorCodeData = '#f44336';
                                        colorPop = false;
                                    "
                                >
                                    #f44336
                                </button>
                                <button
                                    :class="{ on: colorCodeData == '#e91e63' }"
                                    style="background-color: #e91e63"
                                    @click="
                                        colorCodeData = '#e91e63';
                                        colorPop = false;
                                    "
                                >
                                    #e91e63
                                </button>
                                <button
                                    :class="{ on: colorCodeData == '#9c27b0' }"
                                    style="background-color: #9c27b0"
                                    @click="
                                        colorCodeData = '#9c27b0';
                                        colorPop = false;
                                    "
                                >
                                    #9c27b0
                                </button>
                                <button
                                    :class="{ on: colorCodeData == '#673ab7' }"
                                    style="background-color: #673ab7"
                                    @click="
                                        colorCodeData = '#673ab7';
                                        colorPop = false;
                                    "
                                >
                                    #673ab7
                                </button>

                                <button
                                    :class="{ on: colorCodeData == '#3f51b5' }"
                                    style="background-color: #3f51b5"
                                    @click="
                                        colorCodeData = '#3f51b5';
                                        colorPop = false;
                                    "
                                >
                                    #3f51b5
                                </button>
                                <button
                                    :class="{ on: colorCodeData == '#2196f3' }"
                                    style="background-color: #2196f3"
                                    @click="
                                        colorCodeData = '#2196f3';
                                        colorPop = false;
                                    "
                                >
                                    #2196f3
                                </button>
                                <button
                                    :class="{ on: colorCodeData == '#03a9f4' }"
                                    style="background-color: #03a9f4"
                                    @click="
                                        colorCodeData = '#03a9f4';
                                        colorPop = false;
                                    "
                                >
                                    #03a9f4
                                </button>
                                <button
                                    :class="{ on: colorCodeData == '#00bcd4' }"
                                    style="background-color: #00bcd4"
                                    @click="
                                        colorCodeData = '#00bcd4';
                                        colorPop = false;
                                    "
                                >
                                    #00bcd4
                                </button>

                                <button
                                    :class="{ on: colorCodeData == '#009688' }"
                                    style="background-color: #009688"
                                    @click="
                                        colorCodeData = '#009688';
                                        colorPop = false;
                                    "
                                >
                                    #009688
                                </button>
                                <button
                                    :class="{ on: colorCodeData == '#4caf50' }"
                                    style="background-color: #4caf50"
                                    @click="
                                        colorCodeData = '#4caf50';
                                        colorPop = false;
                                    "
                                >
                                    #4caf50
                                </button>
                                <button
                                    :class="{ on: colorCodeData == '#8bc34a' }"
                                    style="background-color: #8bc34a"
                                    @click="
                                        colorCodeData = '#8bc34a';
                                        colorPop = false;
                                    "
                                >
                                    #8bc34a
                                </button>
                                <button
                                    :class="{ on: colorCodeData == '#cddc39' }"
                                    style="background-color: #cddc39"
                                    @click="
                                        colorCodeData = '#cddc39';
                                        colorPop = false;
                                    "
                                >
                                    #cddc39
                                </button>

                                <button
                                    :class="{ on: colorCodeData == '#ffeb3b' }"
                                    style="background-color: #ffeb3b"
                                    @click="
                                        colorCodeData = '#ffeb3b';
                                        colorPop = false;
                                    "
                                >
                                    #ffeb3b
                                </button>
                                <button
                                    :class="{ on: colorCodeData == '#ffc107' }"
                                    style="background-color: #ffc107"
                                    @click="
                                        colorCodeData = '#ffc107';
                                        colorPop = false;
                                    "
                                >
                                    #ffc107
                                </button>
                                <button
                                    :class="{ on: colorCodeData == '#ff9800' }"
                                    style="background-color: #ff9800"
                                    @click="
                                        colorCodeData = '#ff9800';
                                        colorPop = false;
                                    "
                                >
                                    #ff9800
                                </button>
                                <button
                                    :class="{ on: colorCodeData == '#ff5722' }"
                                    style="background-color: #ff5722"
                                    @click="
                                        colorCodeData = '#ff5722';
                                        colorPop = false;
                                    "
                                >
                                    #ff5722
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        스케줄표 노출여부
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-radio">
                            <input id="radio-s1-1" checked name="radio-s1" type="radio" />
                            <label for="radio-s1-1">노출</label>
                        </div>
                        <div class="com-radio">
                            <input id="radio-s1-2" name="radio-s1" type="radio" />
                            <label for="radio-s1-2">미노출</label>
                        </div>
                        <span class="sub-info">※ 일일스케줄/그룹주간표/강사주간표/룸스케줄에 노출합니다.</span>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        회원예약 노출여부
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-radio">
                            <input id="radio-s2-1" checked name="radio-s2" type="radio" />
                            <label for="radio-s2-1">노출</label>
                        </div>
                        <div class="com-radio">
                            <input id="radio-s2-2" name="radio-s2" type="radio" />
                            <label for="radio-s2-2">미노출</label>
                        </div>
                        <span class="sub-info">※ 회원예약 어플리케이션에 노출합니다.</span>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">정보 노출여부</span>
                    <div class="input-cnt">
                        <div class="com-check">
                            <input id="check-c1-1" name="check-c1" type="checkbox" />
                            <label for="check-c1-1">휴대전화</label>
                        </div>
                        <div class="com-check">
                            <input id="check-c1-2" name="check-c1" type="checkbox" />
                            <label for="check-c1-2">이메일</label>
                        </div>
                        <div class="com-check">
                            <input id="check-c1-3" name="check-c1" type="checkbox" />
                            <label for="check-c1-3">자격증 및 경력사항</label>
                        </div>
                        <span class="sub-info">※ 체크 시, 회원예약 어플리케이션 '강사정보보기'에 노출됩니다.</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="com-card-input half-type">
            <div class="left-box">
                <div class="line">
                    <span class="tit">센터</span>
                    <div class="input-cnt">
                        <select-form :select-data="['선택']" class="w220"></select-form>
                    </div>
                </div>
                <div class="line">
                    <div class="division">
                        <span class="tit">
                            회원명
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input class="w220" type="text" />
                        </div>
                    </div>
                    <div class="division">
                        <span class="tit">닉네임</span>
                        <div class="input-cnt">
                            <input class="w220" type="text" />
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        성별
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-radio">
                            <input id="radio-1-1" checked name="radio-1" type="radio" />
                            <label for="radio-1-1">남성</label>
                        </div>
                        <div class="com-radio">
                            <input id="radio-1-2" name="radio-1" type="radio" />
                            <label for="radio-1-2">여성</label>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">생년월일</span>
                    <div class="input-cnt">
                        <single-calendar class="w220"></single-calendar>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">회원그룹</span>
                    <div class="input-cnt">
                        <select-form :select-data="['선택']" class="w220"></select-form>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        연락처
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-tel select-type">
                            <input type="text" />
                            <input type="text" />
                            <input type="text" />
                            <button class="com-btn">중복확인</button>
                            <span class="error red">중복된 번호입니다.</span>
                        </div>
                    </div>
                    <div class="sub">
                        <div class="com-check">
                            <input id="phone-check-1" name="phone-check" type="checkbox" />
                            <label for="phone-check-1">보호자 연락처</label>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">현금영수증</span>
                    <div class="input-cnt">
                        <div class="com-tel select-type">
                            <input type="text" />
                            <input type="text" />
                            <input type="text" />
                        </div>
                    </div>
                    <div class="sub">
                        <div class="com-check">
                            <input id="phone-check-2" name="phone-check-2" type="checkbox" />
                            <label for="phone-check-2">연락처와 동일</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-box">
                <div class="line">
                    <span class="tit">사진</span>
                    <div class="input-cnt photo-line">
                        <span class="photo">
                            <img alt="사진" src="/img/icons/no_photo.jpg" />
                        </span>
                        <div class="info-txt">
                            <span class="txt">※ 권장 이미지 : 정사각형 사이즈, JPG, PNG 가능</span>
                            <b-form-file id="file1" accept=".jpg, .png, .gif" plain></b-form-file>
                            <label class="com-btn" for="file1">파일첨부</label>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        출석체크번호
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <input class="w220" type="text" />
                        <button class="com-btn">중복확인</button>
                        <span class="error green">사용 가능합니다.</span>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        이메일
                        <span class="info">※ 회원 APP 사용 시, 접속 아이디로 사용됩니다.</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-email">
                            <input class="first" type="text" />
                            <span class="txt">@</span>
                            <input class="last" type="text" />
                            <select-form :select-data="['선택']"></select-form>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">주소</span>
                    <div class="input-cnt">
                        <input class="max-400 calc-100" readonly type="text" />
                        <button class="com-btn">주소검색</button>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">마케팅 동의여부</span>
                    <div class="input-cnt">
                        <div class="com-check">
                            <input id="check-1-1" name="check-1" type="checkbox" />
                            <label for="check-1-1">이메일</label>
                        </div>
                        <div class="com-check">
                            <input id="check-1-2" name="check-1" type="checkbox" />
                            <label for="check-1-2">SMS/MMS</label>
                        </div>
                        <div class="com-check">
                            <input id="check-1-3" name="check-1" type="checkbox" />
                            <label for="check-1-3">PUSH</label>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">메모</span>
                    <div class="input-cnt">
                        <textarea class="com-textarea w400"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <button class="com-btn">취소</button>
            <button class="com-btn blue">저장</button>
        </div>

        <p class="com-sub-title">이용권 결제 / 예약 안내 com-sub-title</p>

        <div class="com-table-top">
            <span class="title">이용권결제등록</span>
        </div>
        <div class="com-table-wrap">
            <span class="top-title"><span class="title">이용권 기본정보</span></span>
            <div class="com-card-input half-type">
                <div class="left-box">
                    <div class="line">
                        <span class="tit">
                            센터
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <select-form :select-data="['선택']" class="w220"></select-form>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            회원명
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input class="w220" readonly type="text" />
                            <button class="com-btn" @click="userPop = true">검색</button>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            이용권명
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <select-form :select-data="['선택']" class="w220"></select-form>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            입력자
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <select-form :select-data="['선택']" class="w220"></select-form>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">메모</span>
                        <div class="input-cnt">
                            <textarea class="com-textarea w400"></textarea>
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <!-- 이용권 정보 -->
                    <div class="info-box">
                        <span class="title">이용권 기본정보</span>
                        <span class="sub-title">
                            [개인] 필라테스 10회
                            <!-- 이용권 정보 2개 이상 있을시 나오는 버튼 -->
                            <span class="right-btn">
                                <button class="com-btn red">기간연장</button>
                                <button class="com-btn">연장내역</button>
                                <button class="com-btn blue">히스토리 내역</button>
                            </span>
                            <!-- //이용권 정보 2개 이상 있을시 나오는 버튼 -->
                        </span>
                        <div class="line">
                            <span class="tit">
                                유효기간
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-calendar-wrap">
                                    <single-calendar></single-calendar>
                                    <div class="com-dash"><span class="dash">~</span></div>
                                    <single-calendar></single-calendar>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">정상가</span>
                            <div class="input-cnt">
                                <input class="w220" readonly type="text" />
                                <span class="txt">원</span>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                실제구매가
                                <span class="imp">*</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">이용권 결제등록 완료시점에 자동발송 됩니다.</span>
                                        <p class="txt">
                                            <span class="red">[추가 사용 가능한 치환문자]</span>
                                            <br />
                                            [담당강사] : 이용권의 지정된 담당강사
                                            <br />
                                            [이용권명] : 이용권명
                                            <br />
                                            [유효기간] : (예시 : 2020-01-01 ~ 2020-02-28)
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <input class="w220" readonly type="text" />
                                <span class="txt">원</span>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                횟수
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <span class="txt">총</span>
                                <input class="w70" readonly type="text" />
                                <span class="txt">회</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                수업시간
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <select-form :select-data="['선택']" class="w70"></select-form>
                                <span class="txt">시간</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                </div>
                                <select-form :select-data="['선택']" class="w70"></select-form>
                                <span class="txt">회</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                매출직원
                                <span class="imp">*</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <select-form :select-data="['선택']" class="w220"></select-form>
                                <div class="com-radio">
                                    <input id="radio-s1-1" checked name="radio-s1" type="radio" />
                                    <label for="radio-s1-1">카드</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-s1-2" name="radio-s1" type="radio" />
                                    <label for="radio-s1-2">현금</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                담당강사
                                <span class="imp">*</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <select-form :select-data="['선택']" class="w220"></select-form>
                                <div class="com-radio">
                                    <input id="radio-s2-1" checked name="radio-s2" type="radio" />
                                    <label for="radio-s2-1">신규</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-s2-2" name="radio-s2" type="radio" />
                                    <label for="radio-s2-2">재등록</label>
                                </div>
                            </div>
                            <div class="sub-line">
                                <div class="com-check">
                                    <input id="check-s1-1" name="check-1" type="checkbox" />
                                    <label for="check-s1-1">지정된 담당강사에게만 예약이 가능하게 적용</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                1회 당 정산금액
                                <small>(필요할 경우에만 입력)</small>
                            </span>
                            <div class="input-cnt">
                                <input class="w220" placeholder="필요 시 입력" type="text" />
                                <span class="txt">원</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- //이용권 정보 -->
                    <!-- 이용권 정보 -->
                    <div class="info-box">
                        <span class="title">이용권 기본정보</span>
                        <span class="sub-title">
                            [개인] 요가 10회
                            <!-- 이용권 정보 2개 이상 있을시 나오는 버튼 -->
                            <span class="right-btn">
                                <button class="com-btn red">기간연장</button>
                                <button class="com-btn">연장내역</button>
                                <button class="com-btn blue">히스토리 내역</button>
                            </span>
                            <!-- //이용권 정보 2개 이상 있을시 나오는 버튼 -->
                        </span>
                        <div class="line">
                            <span class="tit">
                                유효기간
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-calendar-wrap">
                                    <single-calendar></single-calendar>
                                    <div class="com-dash"><span class="dash">~</span></div>
                                    <single-calendar></single-calendar>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">정상가</span>
                            <div class="input-cnt">
                                <input class="w220" readonly type="text" />
                                <span class="txt">원</span>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                실제구매가
                                <span class="imp">*</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <input class="w220" readonly type="text" />
                                <span class="txt">원</span>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                횟수
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <span class="txt">총</span>
                                <input class="w70" readonly type="text" />
                                <span class="txt">회</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                수업시간
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <select-form :select-data="['선택']" class="w70"></select-form>
                                <span class="txt">시간</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                </div>
                                <select-form :select-data="['선택']" class="w70"></select-form>
                                <span class="txt">회</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                매출직원
                                <span class="imp">*</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <select-form :select-data="['선택']" class="w220"></select-form>
                                <div class="com-radio">
                                    <input id="radio-t1-1" checked name="radio-t1" type="radio" />
                                    <label for="radio-t1-1">카드</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-t1-2" name="radio-t1" type="radio" />
                                    <label for="radio-t1-2">현금</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                담당강사
                                <span class="imp">*</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <select-form :select-data="['선택']" class="w220"></select-form>
                                <div class="com-radio">
                                    <input id="radio-t2-1" checked name="radio-t2" type="radio" />
                                    <label for="radio-t2-1">신규</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-t2-2" name="radio-t2" type="radio" />
                                    <label for="radio-t2-2">재등록</label>
                                </div>
                            </div>
                            <div class="sub-line">
                                <div class="com-check">
                                    <input id="check-t1-1" name="check-1" type="checkbox" />
                                    <label for="check-t1-1">지정된 담당강사에게만 예약이 가능하게 적용</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                1회 당 정산금액
                                <small>(필요할 경우에만 입력)</small>
                            </span>
                            <div class="input-cnt">
                                <input class="w220" placeholder="필요 시 입력" type="text" />
                                <span class="txt">원</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- //이용권 정보 -->
                </div>
            </div>

            <span class="top-title"><span class="title">이용권 결제정보</span></span>

            <div class="com-card-form">
                <div class="top-area">
                    <div class="line">
                        <span class="txt w120">결제 예정 금액 :</span>
                        <span class="input-box">
                            <input class="w220" disabled type="text" />
                            원
                        </span>
                    </div>
                </div>
                <div class="middle-area">
                    <!-- 결제 정보 -->
                    <payment-info></payment-info>

                    <div class="com-send-btn">
                        <button class="com-btn blue">결제정보추가</button>
                    </div>

                    <!-- 환불 정보 -->
                    <div class="payment-box">
                        <span class="title">환불정보 - 1</span>
                        <ul class="info-list">
                            <li>
                                <span class="tit">환불직원 :</span>
                                <div class="info">
                                    <input class="w220" type="text" />
                                </div>
                            </li>
                            <li>
                                <span class="tit">환불신청 :</span>
                                <div class="info">
                                    <single-calendar class="w220"></single-calendar>
                                    <span class="txt red">(2020-01-02 환불완료)</span>
                                </div>
                            </li>
                            <li>
                                <span class="tit">사용금액 :</span>
                                <div class="info">
                                    <input class="w220" type="text" />
                                    <span class="txt">원</span>
                                </div>
                            </li>
                            <li>
                                <span class="tit">환불금액 :</span>
                                <div class="info">
                                    <input class="w220" type="text" />
                                    <span class="txt">원</span>
                                </div>
                            </li>
                            <li>
                                <span class="tit">마일리지 :</span>
                                <div class="info">
                                    <input class="w220" type="text" />
                                    <span class="txt">원 차감예정</span>
                                </div>
                            </li>
                            <li>
                                <span class="tit">환불수단 :</span>
                                <div class="info">
                                    <input class="w400" type="text" />
                                </div>
                            </li>
                            <li>
                                <span class="tit">환불사유 :</span>
                                <div class="info">
                                    <textarea class="with-btn"></textarea>
                                    <div class="right-btn">
                                        <button class="com-btn">수정</button>
                                        <button class="com-btn red">삭제</button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="bottom-total">
                        <span class="tit">결제 후 미수금액 :</span>
                        <span class="num">100,000 원</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="lesson-info-card">
            <div class="left type-1">개인레슨 10회</div>
            <!-- type-1: 개인, type-2: 그룹, type-3: 패키지, type-4: 회원권, type-5: 듀엣, type-6: OT -->
            <div class="right">
                <span class="num">
                    990,000
                    <small>원</small>
                </span>
                <span class="info">10회 / 유효기간 2개월 / 필라테스</span>
            </div>
        </div>

        <p class="sub-title">
            이용권 등록
            <a class="com-btn blue right" href="#">목록보기</a>
        </p>

        <div class="com-table-wrap">
            <span class="top-title">
                <span class="title">기본정보</span>
            </span>
            <div class="com-card-input half-type full">
                <div class="left-box">
                    <div class="line">
                        <span class="tit">
                            이용권 구분
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <span class="type-icon type-1">개인</span>
                            <!-- type-1: 개인, type-2: 그룹, type-3: 패키지, type-4: 회원권, type-5: 듀엣, type-6: OT -->
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            이용권 구분
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <div class="com-box-radio">
                                <input id="box-check-1-1" checked name="box-check" type="radio" />
                                <label for="box-check-1-1">개인</label>
                            </div>
                            <div class="com-box-radio">
                                <input id="box-check-1-2" name="box-check" type="radio" />
                                <label for="box-check-1-2">OT</label>
                            </div>
                            <div class="com-box-radio">
                                <input id="box-check-1-3" name="box-check" type="radio" />
                                <label for="box-check-1-3">듀엣</label>
                            </div>
                            <div class="com-box-radio">
                                <input id="box-check-1-4" name="box-check" type="radio" />
                                <label for="box-check-1-4">그룹</label>
                            </div>
                            <div class="com-box-radio">
                                <input id="box-check-1-5" name="box-check" type="radio" />
                                <label for="box-check-1-5">쿠폰</label>
                            </div>
                            <div class="com-box-radio">
                                <input id="box-check-1-6" name="box-check" type="radio" />
                                <label for="box-check-1-6">회원권</label>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            이용권 명
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input class="w640" placeholder="예 ) 개인레슨 10회" type="text" />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">이용권 설명</span>
                        <div class="input-cnt">
                            <input class="w640" placeholder="이용권 설명이 필요한 경우 입력해주세요" type="text" />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">카테고리</span>
                        <div class="input-cnt">
                            <div class="com-check">
                                <input id="select-cate-1" name="select-cate-1" type="checkbox" />
                                <label for="select-cate-1">여름할인권</label>
                            </div>
                            <div class="com-check">
                                <input id="select-cate-2" name="select-cate-1" type="checkbox" />
                                <label for="select-cate-2">스피닝</label>
                            </div>
                            <div class="com-check">
                                <input id="select-cate-3" name="select-cate-1" type="checkbox" />
                                <label for="select-cate-3">임산부그룹</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="line-box">
                    <div class="left-box">
                        <div class="line">
                            <span class="tit">
                                유효기간
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input class="center w90" type="text" />
                                <div class="com-radio">
                                    <input id="radio-s1-1" checked name="radio-s1" type="radio" />
                                    <label for="radio-s1-1">개월</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-s1-2" name="radio-s1" type="radio" />
                                    <label for="radio-s1-2">일</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                횟수
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input id="radio-s2-1" checked name="radio-s2" type="radio" />
                                    <label for="radio-s2-1">총 횟수</label>
                                </div>
                                <input class="center w90" placeholder="예) 3" type="text" />
                                <span class="txt">회</span>
                                <div class="com-radio">
                                    <input id="radio-s2-2" name="radio-s2" type="radio" />
                                    <label for="radio-s2-2">주</label>
                                </div>
                                <input class="center w90" placeholder="예) 3" type="text" />
                                <span class="txt">회</span>
                                <div class="com-radio">
                                    <input id="radio-s2-3" name="radio-s2" type="radio" />
                                    <label for="radio-s2-3">
                                        무제한
                                        <small>(횟수제한 없는 자유이용)</small>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                수업시간
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">수업시간</span>
                                        <p class="txt">
                                            기본은 1시간당 1회를 기준으로 합니다.
                                            <br />
                                            필요할 경우 수업시간 당 강사의 수업횟수에 몇 회로 포함할 지 변경할 수
                                            있습니다.
                                            <br />
                                            <br />

                                            예) 30분의 수업을 강사에게 1회라고 인정하는 센터도 있는 반면, 0.5회로
                                            적용하는 센터도 있습니다.
                                            <br />
                                            <br />

                                            여기서 적용한 시간 당 횟수는 급여 메뉴에서 확인하는 강사의 총 수업횟수를
                                            합산하는데 적용됩니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="top-txt">
                                    <span class="txt">1회 당</span>
                                    <select-form :select-data="['선택']" class="w180"></select-form>
                                </div>
                                <div class="top-txt">
                                    <span class="txt">강사에게</span>
                                    <select-form :select-data="['선택']" class="w180"></select-form>
                                    <span class="sub-txt">의 수업으로 적용합니다.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="line">
                            <span class="tit">
                                금액
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input class="center w220" type="text" />
                                <span class="txt">원</span>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                회당단가
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">회당단가</span>
                                        <p class="txt">
                                            기본은 1시간당 1회를 기준으로 합니다.
                                            <br />
                                            주 N회의 경우는 유효기간에 따라 전체 횟수가 다를 수 있으므로 평균금액으로
                                            보여지며 정확하지 않을 수 있습니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <input class="center w220" readonly type="text" />
                                <span class="txt">원</span>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                부가세
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">부가세</span>
                                        <p class="txt">
                                            설정한 부가세는 매출에 적용됩니다.
                                            <br />
                                            강사의 급여가 %인 경우, 부가세를 제외하고 정산하는 것은 강사개별급여
                                            설정에서 적용해주세요.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input id="radio-s3-1" name="radio-s3" type="radio" />
                                    <label for="radio-s3-1">부가세 미적용</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-s3-2" name="radio-s3" type="radio" />
                                    <label for="radio-s3-2">부가세 10% 적용</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                판매여부
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">판매여부</span>
                                        <p class="txt">
                                            이용권 판매를 잠시 중단해야 하는 경우 '판매정지’를 선택하여 이용권 판매를
                                            중지할 수 있습니다.
                                            <br />
                                            추후 다시 '판매중'으로 변경 가능합니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input id="radio-s4-1" name="radio-s4" type="radio" />
                                    <label for="radio-s4-1">판매중</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-s4-2" name="radio-s4" type="radio" />
                                    <label for="radio-s4-2">판매정지</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="com-table-wrap">
            <span class="top-title"><span class="title">계약정보</span></span>
            <div class="info-edit-table">
                <div class="table-wrapper">
                    <table>
                        <colgroup>
                            <col style="width: 156px" />
                            <col style="width: auto" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>로고</th>
                                <td>
                                    <div class="file-logo">
                                        <span class="logo"><img alt="" src="/img/temp/brand_logo.png" /></span>
                                    </div>
                                    <div class="com-file-single">
                                        <b-form-file id="file1" accept=".jpg, .png, .gif" plain></b-form-file>
                                        <label for="file1">파일첨부</label>
                                        <span class="info-txt">
                                            <span class="imp">*</span>
                                            흰 배경에 180px × 70px 사이즈 로고를 권장합니다.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    센터
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <button class="plus-btn">센터선택</button>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    사업자번호
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input class="w400" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <th>상품</th>
                                <td>
                                    <select-form :select-data="['선택']" class="w240"></select-form>
                                    <table class="sub-table">
                                        <colgroup>
                                            <col style="width: 150px" />
                                            <col style="width: auto" />
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th>사용기간</th>
                                                <td>
                                                    <div class="com-calendar-wrap">
                                                        <single-calendar></single-calendar>
                                                        <div class="com-dash"><span class="dash">~</span></div>
                                                        <single-calendar></single-calendar>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>계약금액</th>
                                                <td>
                                                    <input class="w130" disabled type="text" />
                                                    <span class="txt">원</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <th>계약일</th>
                                <td>
                                    <single-calendar></single-calendar>
                                </td>
                            </tr>
                            <tr>
                                <th>전화번호</th>
                                <td>
                                    <div class="com-tel">
                                        <input type="text" />
                                        <span class="bar">-</span>
                                        <input type="text" />
                                        <span class="bar">-</span>
                                        <input type="text" />
                                    </div>
                                    <div class="com-tel select-type">
                                        <input type="text" />
                                        <input type="text" />
                                        <input type="text" />
                                        <button class="com-btn">중복확인</button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>이메일</th>
                                <td>
                                    <div class="com-email">
                                        <input class="first" type="text" />
                                        <span class="txt">@</span>
                                        <input class="last" type="text" />
                                        <select-form :select-data="['선택']"></select-form>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>주소</th>
                                <td>
                                    <div class="com-address">
                                        <input class="address" type="text" />
                                        <button class="com-btn">주소검색</button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>메모</th>
                                <td>
                                    <textarea class="com-textarea w680"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p class="sub-title">락커정보</p>

                <div class="com-table-wrap">
                    <span class="top-title"><span class="title">대여정보</span></span>
                    <div class="com-card-form">
                        <div class="top-area">
                            <div class="line">
                                <span class="top-txt">센터</span>
                                <div class="input-line">
                                    <select-form :select-data="['선택']" class="w640"></select-form>
                                </div>
                            </div>
                            <div class="line">
                                <span class="top-txt">락커구분</span>
                                <div class="input-line">
                                    <select-form :select-data="['선택']" class="w640"></select-form>
                                </div>
                            </div>
                            <div class="line">
                                <span class="top-txt">성별</span>
                                <div class="input-line">
                                    <div class="com-radio">
                                        <input id="radio-top-1" checked name="radio-top" type="radio" />
                                        <label for="radio-top-1">공통</label>
                                    </div>
                                    <div class="com-radio">
                                        <input id="radio-top-2" name="radio-top" type="radio" />
                                        <label for="radio-top-2">남자</label>
                                    </div>
                                    <div class="com-radio">
                                        <input id="radio-top-3" name="radio-top" type="radio" />
                                        <label for="radio-top-3">여자</label>
                                    </div>
                                </div>
                            </div>
                            <div class="line">
                                <span class="top-txt">락커번호</span>
                                <div class="input-line">
                                    <input class="w80 center" type="text" />
                                </div>
                            </div>
                            <div class="line">
                                <span class="top-txt">회원명</span>
                                <div class="input-line">
                                    <input class="w285" placeholder="이름, 연락처 입력" type="text" />
                                    <button class="com-btn">검색</button>
                                </div>
                            </div>
                            <div class="line">
                                <span class="top-txt">금액</span>
                                <div class="input-line">
                                    <select-form :select-data="['선택']" class="w640"></select-form>
                                </div>
                            </div>
                            <div class="line">
                                <span class="top-txt">기간</span>
                                <div class="input-line">
                                    <div class="com-calendar-wrap">
                                        <single-calendar></single-calendar>
                                        <div class="com-dash"><span class="dash">~</span></div>
                                        <single-calendar></single-calendar>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="middle-area">
                            <!-- 결제 정보 -->
                            <payment-info></payment-info>

                            <div class="com-send-btn">
                                <button class="com-btn blue">결제정보추가</button>
                            </div>
                            <div class="bottom-total">
                                <span class="tit">결제 후 미수금액 :</span>
                                <span class="num">0 원</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="com-table-wrap">
                    <span class="top-title"><span class="title">이용권 결제정보</span></span>

                    <div class="com-card-form">
                        <div class="top-area">
                            <div class="line">
                                <span class="txt w120">결제 예정 금액 :</span>
                                <span class="input-box">
                                    <input class="w220" disabled type="text" />
                                    원
                                </span>
                            </div>
                        </div>
                        <div class="middle-area">
                            <!-- 결제 정보 -->
                            <payment-info></payment-info>

                            <div class="com-send-btn">
                                <button class="com-btn blue">결제정보추가</button>
                            </div>

                            <!-- 환불 정보 -->
                            <div class="payment-box">
                                <span class="title">환불정보 - 1</span>
                                <ul class="info-list">
                                    <li>
                                        <span class="tit">환불직원 :</span>
                                        <div class="info">
                                            <input class="w220" type="text" />
                                        </div>
                                    </li>
                                    <li>
                                        <span class="tit">환불신청 :</span>
                                        <div class="info">
                                            <single-calendar class="w220"></single-calendar>
                                            <span class="txt red">(2020-01-02 환불완료)</span>
                                        </div>
                                    </li>
                                    <li>
                                        <span class="tit">사용금액 :</span>
                                        <div class="info">
                                            <input class="w220" type="text" />
                                            <span class="txt">원</span>
                                        </div>
                                    </li>
                                    <li>
                                        <span class="tit">환불금액 :</span>
                                        <div class="info">
                                            <input class="w220" type="text" />
                                            <span class="txt">원</span>
                                        </div>
                                    </li>
                                    <li>
                                        <span class="tit">마일리지 :</span>
                                        <div class="info">
                                            <input class="w220" type="text" />
                                            <span class="txt">원 차감예정</span>
                                        </div>
                                    </li>
                                    <li>
                                        <span class="tit">환불수단 :</span>
                                        <div class="info">
                                            <input class="w400" type="text" />
                                        </div>
                                    </li>
                                    <li>
                                        <span class="tit">환불사유 :</span>
                                        <div class="info">
                                            <textarea class="with-btn"></textarea>
                                            <div class="right-btn">
                                                <button class="com-btn">수정</button>
                                                <button class="com-btn red">삭제</button>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="bottom-total">
                                <span class="tit">결제 후 미수금액 :</span>
                                <span class="num">100,000 원</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="com-card-form">
                    <div class="top-area">
                        <div class="line">
                            <span class="count">
                                <span class="txt">베이직 1년 약정</span>
                                <span class="num">475,200</span>
                                원
                            </span>
                            <span class="count">
                                <span class="txt">문자서비스 1개월</span>
                                <span class="num">475,200</span>
                                원
                            </span>
                            <span class="count">
                                <span class="txt">회원 DB 이전</span>
                                <span class="num">475,200</span>
                                원
                            </span>
                            <span class="count">
                                <span class="txt">터치모니터</span>
                                <span class="num">475,200</span>
                                원
                            </span>
                        </div>
                        <div class="line">
                            <span class="txt">총 결제금액 :</span>
                            <span class="input-box">
                                <input class="w220" disabled type="text" />
                                원
                            </span>
                        </div>
                    </div>
                    <div class="middle-area">
                        <span class="title">결제정보 - 1</span>
                        <ul class="info-list">
                            <li>
                                <span class="tit">결제수단 :</span>
                                <div class="info">
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input id="radio-1-1" checked name="radio-1" type="radio" />
                                            <label for="radio-1-1">카드</label>
                                        </div>
                                        <div class="com-radio">
                                            <input id="radio-1-2" name="radio-1" type="radio" />
                                            <label for="radio-1-2">현금</label>
                                        </div>
                                        <div class="com-radio">
                                            <input id="radio-1-3" name="radio-1" type="radio" />
                                            <label for="radio-1-3">계좌이체</label>
                                        </div>
                                        <div class="com-radio">
                                            <input id="radio-1-4" name="radio-1" type="radio" />
                                            <label for="radio-1-4">마일리지</label>
                                        </div>
                                        <div class="com-radio">
                                            <input id="radio-1-5" name="radio-1" type="radio" />
                                            <label for="radio-1-5">기타</label>
                                        </div>
                                    </div>

                                    <div class="card-radio-box">
                                        <div class="com-radio-btn">
                                            <input id="radio-2-1" checked name="radio-2" type="radio" />
                                            <label for="radio-2-1">KB국민</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input id="radio-2-2" name="radio-2" type="radio" />
                                            <label for="radio-2-2">비씨</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input id="radio-2-3" name="radio-2" type="radio" />
                                            <label for="radio-2-3">삼성</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input id="radio-2-4" name="radio-2" type="radio" />
                                            <label for="radio-2-4">현대</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input id="radio-2-5" name="radio-2" type="radio" />
                                            <label for="radio-2-5">롯데</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input id="radio-2-6" name="radio-2" type="radio" />
                                            <label for="radio-2-6">신한</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input id="radio-2-7" name="radio-2" type="radio" />
                                            <label for="radio-2-7">외한</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input id="radio-2-8" name="radio-2" type="radio" />
                                            <label for="radio-2-8">하나</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input id="radio-2-9" name="radio-2" type="radio" />
                                            <label for="radio-2-9">NH농협</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input id="radio-2-10" name="radio-2" type="radio" />
                                            <label for="radio-2-10">우리</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input id="radio-2-11" name="radio-2" type="radio" />
                                            <label for="radio-2-11">씨티</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input id="radio-2-12" name="radio-2" type="radio" />
                                            <label for="radio-2-12">수협</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input id="radio-2-13" name="radio-2" type="radio" />
                                            <label for="radio-2-13">신협</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input id="radio-2-14" name="radio-2" type="radio" />
                                            <label for="radio-2-14">KDB산업</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input id="radio-2-15" name="radio-2" type="radio" />
                                            <label for="radio-2-15">광주</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input id="radio-2-16" name="radio-2" type="radio" />
                                            <label for="radio-2-16">전북</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input id="radio-2-17" name="radio-2" type="radio" />
                                            <label for="radio-2-17">제주</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input id="radio-2-18" name="radio-2" type="radio" />
                                            <label for="radio-2-18">케이뱅크</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input id="radio-2-10" name="radio-2" type="radio" />
                                            <label for="radio-2-10">카카오뱅크</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input id="radio-2-19" name="radio-2" type="radio" />
                                            <label for="radio-2-19">기타</label>
                                        </div>
                                        <button v-show="!isMoreCard" class="more-btn" @click="isMoreCard = true">
                                            + 더보기
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <span class="tit">결제금액 :</span>
                                <div class="info">
                                    <input type="text" />
                                    <span class="txt">원</span>
                                </div>
                            </li>
                            <li>
                                <span class="tit">결제일자 :</span>
                                <div class="info">
                                    <single-calendar></single-calendar>
                                </div>
                            </li>
                        </ul>
                        <div class="com-send-btn">
                            <button class="com-btn blue">결제정보추가</button>
                        </div>
                    </div>
                </div>
                <div class="bottom-btn">
                    <button class="com-btn">취소</button>
                    <button class="com-btn blue">수정</button>
                </div>
            </div>
        </div>

        <div class="line-gap">
            <div class="com-table-wrap">
                <span class="top-title"><span class="title">문자서비스</span></span>
                <table class="com-table free-size">
                    <colgroup>
                        <col style="width: 220px" />
                        <col style="width: 320px" />
                        <col style="width: 65px" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td><strong>1개월 당 금액</strong></td>
                            <td>
                                <input class="center w195" type="text" />
                                <span class="txt">원</span>
                            </td>
                            <td>
                                <button class="com-btn">수정</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="com-table-wrap">
                <span class="top-title">
                    <span class="title">부가서비스</span>
                    <a class="com-btn gray" href="#">목록</a>
                </span>
                <table class="com-table free-size">
                    <colgroup>
                        <col style="width: 400px" />
                        <col style="width: 280px" />
                        <col style="width: 200px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>서비스명</th>
                            <th>금액</th>
                            <th>관리</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <input class="w100p" type="text" />
                            </td>
                            <td>
                                <input class="center w195" type="text" />
                                <span class="txt">원</span>
                            </td>
                            <td>
                                <button class="com-btn">수정</button>
                                <button class="com-btn red">삭제</button>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input class="w100p" type="text" />
                            </td>
                            <td>
                                <input class="center w195" type="text" />
                                <span class="txt">원</span>
                            </td>
                            <td>
                                <button class="com-btn blue">등록</button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <button class="com-btn blue big">부가서비스 추가</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar></single-calendar>
                </div>
                <select-form :select-data="['선택']" @update:set="(val) => (setValue = val)"></select-form>
            </div>
            <div class="line">
                <select-form :select-data="['선택']"></select-form>
                <select-form :select-data="['선택']"></select-form>
                <button class="com-search-reset"></button>
            </div>
        </div>
        <div class="advice-view-content">
            <div class="top-area">
                <span class="item">
                    <span class="tit">최신상담일자 :</span>
                    <span class="txt">2019-12-23</span>
                </span>
                <span class="item">
                    <span class="tit">회원명 :</span>
                    <span class="txt">홍길동</span>
                </span>
                <span class="item">
                    <span class="tit">상담자 :</span>
                    <span class="txt">김윤경</span>
                </span>
                <span class="item">
                    <span class="tit">상담유형 :</span>
                    <span class="txt">등록</span>
                </span>
                <span class="item">
                    <span class="tit">상담경로 :</span>
                    <span class="txt">전화</span>
                </span>
                <span class="item">
                    <span class="tit">유입경로 :</span>
                    <span class="txt">전단지</span>
                </span>
                <button class="modify-btn" @click="advicePop = true"><span class="blind">수정하기</span></button>
                <button class="del-btn"><span class="blind">삭제하기</span></button>
            </div>
            <div class="view-area com-scroll-y">
                필라테스 3개월 다니다가 새로 옮기고 싶어서 문의 드렸다고 합니다. 1대1 개인레슨 가격 궁금해 하심. 허리
                다친적 있으심.
            </div>
        </div>

        <div class="photo-info-card">
            <span class="photo">
                <img alt="" src="/img/icons/no_photo.jpg" />
            </span>
            <div class="info-txt">
                <span class="txt name">홍길동 (9999)</span>
                <span class="txt">010-9999-9999</span>
                <span class="txt">필라테스 회원</span>
                <span class="txt">복도락커 13번</span>
            </div>
            <span class="icon green">유효</span>
            <!--
                <span class="icon red">만료</span>
                <span class="icon gray">잠재</span>
                <span class="icon yellow">홀딩</span>
            -->
            <button class="send-btn">인증코드전송</button>
        </div>

        <div class="com-notice-list">
            <div class="box">
                <span class="tit">주의사항</span>
                <ul>
                    <li>- 메시지 종류(SMS, LMS, MMS)에 따라 메시지가 잘려서 전송될 수 있습니다.</li>
                    <li>- MMS 이미지 첨부 시 사이즈는 (000 x 000) 이하, 용량 (000 kbyte) 이하로 제한됩니다.</li>
                    <li>- 예상 차감 금액은 실제와 차이가 있을 수 있습니다.</li>
                </ul>
            </div>
            <div class="box">
                <span class="tit">치환문자 안내</span>
                <ul>
                    <li>[회원명] : 회원 이름으로 자동 치환됩니다.</li>
                    <li>[센터명] : 센터명으로 자동 치환됩니다. (핏투데이케어 합정점)</li>
                    <li>[센터번호] : 센터 대표 전화번호로 치환됩니다. (02-454-4542)</li>
                </ul>
            </div>
        </div>

        <div class="phone-list-content">
            <ul>
                <li>
                    <span class="name">핏투데이케어 본사</span>
                    <span class="phone">070 - 5118 - 1694</span>
                    <div class="bottom-btn">
                        <button class="com-btn">인증</button>
                        <button class="com-btn red">삭제</button>
                    </div>
                </li>
                <li>
                    <span class="name">김XX</span>
                    <span class="phone">010-3333-4444</span>
                    <div class="bottom-btn">
                        <button class="com-btn">인증</button>
                        <button class="com-btn red">삭제</button>
                    </div>
                </li>
            </ul>
        </div>

        <div class="radio-info-content">
            <span class="title">정산설정</span>
            <div class="info-area">
                <div class="left-box">
                    <div class="input-line">
                        <span class="tit">터치출석을 이용하여 회원 출석 시</span>
                        <div class="line">
                            <div class="com-radio">
                                <input id="radio-1-1" checked name="radio-1" type="radio" />
                                <label for="radio-1-1">자동정산</label>
                            </div>
                        </div>
                        <div class="line">
                            <div class="com-radio">
                                <input id="radio-1-2" name="radio-1" type="radio" />
                                <label for="radio-1-2">단순 출결처리</label>
                            </div>
                        </div>
                    </div>
                    <div class="input-line">
                        <span class="tit">회원예약 어플에서 직접 출결 승인 시</span>
                        <div class="line">
                            <div class="com-radio">
                                <input id="radio-2-1" checked name="radio-2" type="radio" />
                                <label for="radio-2-1">자동정산</label>
                            </div>
                        </div>
                        <div class="line">
                            <div class="com-radio">
                                <input id="radio-2-2" name="radio-2" type="radio" />
                                <label for="radio-2-2">단순 출결처리</label>
                            </div>
                        </div>
                    </div>
                    <div class="input-line">
                        <span class="tit">강사가 결석처리 했을 경우</span>
                        <div class="line">
                            <div class="com-radio">
                                <input id="radio-3-1" checked name="radio-2" type="radio" />
                                <label for="radio-3-1">자동정산</label>
                            </div>
                        </div>
                        <div class="line">
                            <div class="com-radio">
                                <input id="radio-3-2" name="radio-2" type="radio" />
                                <label for="radio-3-2">단순 출결처리</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <span class="tit">자동정산</span>
                    <p class="txt">자동으로 정산완료 됩니다.</p>
                    <span class="tit">단순출결처리</span>
                    <p class="txt">출석, 결석처리만 되며 정산을 하기 위해서는 관리자가 정산처리를 해주어야 합니다.</p>
                    <span class="tit">단순결석처리</span>
                    <p class="txt">정산을 하기 위해서는 관리자가 정산처리를 해주어야 합니다.</p>
                </div>
            </div>
        </div>

        <div class="com-tab">
            <button class="on">이용권 관리</button>
            <button>패키지 관리</button>
            <button>카테고리 관리</button>
        </div>

        <div class="lesson-info-card">
            <div class="left type-1">개인레슨 10회</div>
            <!-- type-1: 개인, type-2: 그룹, type-3: 패키지, type-4: 회원권, type-5: 듀엣, type-6: OT -->
            <div class="right">
                <span class="num">
                    990,000
                    <small>원</small>
                </span>
                <span class="info">10회 / 유효기간 2개월 / 필라테스</span>
            </div>
        </div>

        <p class="sub-title">
            이용권 등록
            <a class="com-btn blue right" href="#">목록보기</a>
        </p>

        <div class="com-table-wrap">
            <span class="top-title">
                <span class="title">기본정보</span>
            </span>
            <div class="com-card-input half-type full">
                <div class="left-box full">
                    <div class="line">
                        <span class="tit">
                            이용권 구분
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <span class="type-icon type-1">개인</span>
                            <!-- type-1: 개인, type-2: 그룹, type-3: 패키지, type-4: 회원권, type-5: 듀엣, type-6: OT -->
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            이용권 구분
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <div class="com-box-radio">
                                <input id="box-check-1-1" checked name="box-check" type="radio" />
                                <label for="box-check-1-1">개인</label>
                            </div>
                            <div class="com-box-radio">
                                <input id="box-check-1-2" name="box-check" type="radio" />
                                <label for="box-check-1-2">OT</label>
                            </div>
                            <div class="com-box-radio">
                                <input id="box-check-1-3" name="box-check" type="radio" />
                                <label for="box-check-1-3">듀엣</label>
                            </div>
                            <div class="com-box-radio">
                                <input id="box-check-1-4" name="box-check" type="radio" />
                                <label for="box-check-1-4">그룹</label>
                            </div>
                            <div class="com-box-radio">
                                <input id="box-check-1-5" name="box-check" type="radio" />
                                <label for="box-check-1-5">쿠폰</label>
                            </div>
                            <div class="com-box-radio">
                                <input id="box-check-1-6" name="box-check" type="radio" />
                                <label for="box-check-1-6">회원권</label>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            이용권 명
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input class="w640" placeholder="예 ) 개인레슨 10회" type="text" />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">이용권 설명</span>
                        <div class="input-cnt">
                            <input class="w640" placeholder="이용권 설명이 필요한 경우 입력해주세요" type="text" />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">카테고리</span>
                        <div class="input-cnt">
                            <div class="com-check">
                                <input id="select-cate-1" name="select-cate-1" type="checkbox" />
                                <label for="select-cate-1">여름할인권</label>
                            </div>
                            <div class="com-check">
                                <input id="select-cate-2" name="select-cate-1" type="checkbox" />
                                <label for="select-cate-2">스피닝</label>
                            </div>
                            <div class="com-check">
                                <input id="select-cate-3" name="select-cate-1" type="checkbox" />
                                <label for="select-cate-3">임산부그룹</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="line-box">
                    <div class="left-box">
                        <div class="line">
                            <span class="tit">
                                유효기간
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input class="center w90" type="text" />
                                <div class="com-radio">
                                    <input id="radio-s1-1" checked name="radio-s1" type="radio" />
                                    <label for="radio-s1-1">개월</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-s1-2" name="radio-s1" type="radio" />
                                    <label for="radio-s1-2">일</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                횟수
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input id="radio-s2-1" checked name="radio-s2" type="radio" />
                                    <label for="radio-s2-1">총 횟수</label>
                                </div>
                                <input class="center w90" placeholder="예) 3" type="text" />
                                <span class="txt">회</span>
                                <div class="com-radio">
                                    <input id="radio-s2-2" name="radio-s2" type="radio" />
                                    <label for="radio-s2-2">주</label>
                                </div>
                                <input class="center w90" placeholder="예) 3" type="text" />
                                <span class="txt">회</span>
                                <div class="com-radio">
                                    <input id="radio-s2-3" name="radio-s2" type="radio" />
                                    <label for="radio-s2-3">
                                        무제한
                                        <small>(횟수제한 없는 자유이용)</small>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                수업시간
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">수업시간</span>
                                        <p class="txt">
                                            기본은 1시간당 1회를 기준으로 합니다.
                                            <br />
                                            필요할 경우 수업시간 당 강사의 수업횟수에 몇 회로 포함할 지 변경할 수
                                            있습니다.
                                            <br />
                                            <br />

                                            예) 30분의 수업을 강사에게 1회라고 인정하는 센터도 있는 반면, 0.5회로
                                            적용하는 센터도 있습니다.
                                            <br />
                                            <br />

                                            여기서 적용한 시간 당 횟수는 급여 메뉴에서 확인하는 강사의 총 수업횟수를
                                            합산하는데 적용됩니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="top-txt">
                                    <span class="txt">1회 당</span>
                                    <select-form :select-data="['선택']" class="w180"></select-form>
                                </div>
                                <div class="top-txt">
                                    <span class="txt">강사에게</span>
                                    <select-form :select-data="['선택']" class="w180"></select-form>
                                    <span class="sub-txt">의 수업으로 적용합니다.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="line">
                            <span class="tit">
                                금액
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input class="center w220" type="text" />
                                <span class="txt">원</span>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                회당단가
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">회당단가</span>
                                        <p class="txt">
                                            기본은 1시간당 1회를 기준으로 합니다.
                                            <br />
                                            주 N회의 경우는 유효기간에 따라 전체 횟수가 다를 수 있으므로 평균금액으로
                                            보여지며 정확하지 않을 수 있습니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <input class="center w220" readonly type="text" />
                                <span class="txt">원</span>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                부가세
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">부가세</span>
                                        <p class="txt">
                                            설정한 부가세는 매출에 적용됩니다.
                                            <br />
                                            강사의 급여가 %인 경우, 부가세를 제외하고 정산하는 것은 강사개별급여
                                            설정에서 적용해주세요.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input id="radio-s3-1" name="radio-s3" type="radio" />
                                    <label for="radio-s3-1">부가세 미적용</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-s3-2" name="radio-s3" type="radio" />
                                    <label for="radio-s3-2">부가세 10% 적용</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                판매여부
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">판매여부</span>
                                        <p class="txt">
                                            이용권 판매를 잠시 중단해야 하는 경우 '판매정지’를 선택하여 이용권 판매를
                                            중지할 수 있습니다.
                                            <br />
                                            추후 다시 '판매중'으로 변경 가능합니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input id="radio-s4-1" name="radio-s4" type="radio" />
                                    <label for="radio-s4-1">판매중</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-s4-2" name="radio-s4" type="radio" />
                                    <label for="radio-s4-2">판매정지</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="com-table-wrap">
            <span class="top-title">
                <span class="title">예약설정</span>
            </span>
            <div class="com-card-input half-type full">
                <div class="line-box">
                    <div class="left-box">
                        <div class="line">
                            <span class="tit">
                                회원예약 어플리케이션을 통해 회원이 직접 예약할 수 있도록 하시겠습니까?
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <p class="txt">
                                            해당 이용권이 회원예약 어플리케이션을 통해 수업예약이 가능한지 여부를
                                            설정합니다.
                                            <br />
                                            '아니오'로 설정한 경우 회원은 예약할 수 없으며 관리자버전에서만 가능합니다.
                                            <br />
                                            자세한 예약제한 시간은 [센터설정>예약시간설정>회원예약 앱] 메뉴에서
                                            설정해주세요.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input id="radio-s5-1" name="radio-s5" type="radio" />
                                    <label for="radio-s5-1">네</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-s5-2" name="radio-s1" type="radio" />
                                    <label for="radio-s5-2">아니오</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                당일중복예약
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">당일중복예약</span>
                                        <p class="txt">
                                            스케줄 예약 시, 당일 중복예약이 가능한지 설정합니다. '하루 여러 번
                                            예약가능'으로 선택 시, 하루에 두 번 이상 스케줄 예약이 가능합니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input id="radio-s6-1" name="radio-s6" type="radio" />
                                    <label for="radio-s6-1">하루 '여러 번' 예약 가능</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-s6-2" name="radio-s6" type="radio" />
                                    <label for="radio-s6-2">하루 '한 번' 예약 가능</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                취소횟수 제한
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">취소횟수 제한</span>
                                        <p class="txt">
                                            회원APP에서 예약된 수업에 대해 한 주에 몇 번 취소가 가능한지 설정 할 수
                                            있습니다.
                                            <br />
                                            관리자버전에서는 취소횟수제한과 상관없이 예약취소 가능합니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input id="radio-s7-1" name="radio-s7" type="radio" />
                                    <label for="radio-s7-1">무제한</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-s7-2" name="radio-s7" type="radio" />
                                    <label for="radio-s7-2">주당 총</label>
                                </div>
                                <input class="center w90" placeholder="예) 3" type="text" />
                                <span class="txt">회</span>
                            </div>
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="line">
                            <span class="tit">
                                예약횟수 제한
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">예약횟수 제한</span>
                                        <p class="txt">
                                            이용권의 주당 사용 횟수를 제한합니다. 관리자 및 회원예약 어플리케이션에서
                                            스케줄 예약 시 적용됩니다.
                                            <br />
                                            예1) 총 횟수 10회 이면서 예약횟수 제한을 주 2회로 설정한 경우, 주당 2회씩만
                                            예약사용 가능함.
                                            <br />
                                            예2) 횟수 주 2회인 경우 예약횟수 제한은 주 2회로 자동 설정됨.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input id="radio-s8-1" name="radio-s8" type="radio" />
                                    <label for="radio-s8-1">무제한</label>
                                </div>
                                <div class="com-radio">
                                    <input id="radio-s8-2" name="radio-s8" type="radio" />
                                    <label for="radio-s8-2">주당 총</label>
                                </div>
                                <input class="center w90" placeholder="예) 3" type="text" />
                                <span class="txt">회</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="com-table-wrap">
            <div class="com-card-input half-type full">
                <div class="left-box full">
                    <div class="line">
                        <span class="tit">
                            락커명
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input class="w640" placeholder="예 ) 복도앞 락커" type="text" />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">설명</span>
                        <div class="input-cnt">
                            <input class="w640" placeholder="예 ) 개인레슨 10회" type="text" />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">성별구분</span>
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input id="radio-1-1" checked name="radio-1" type="radio" />
                                <label for="radio-1-1">공통</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-1-2" name="radio-1" type="radio" />
                                <label for="radio-1-2">남자</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-1-3" name="radio-1" type="radio" />
                                <label for="radio-1-3">여자</label>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            락커번호
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input class="w60 center" type="text" />
                            ~
                            <input class="w60 center" type="text" />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            금액설정
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <div class="sub-box w210">
                                <div class="com-radio">
                                    <input id="radio-2-1" name="radio-2" type="radio" />
                                    <label for="radio-2-1">1개월 고정금액</label>
                                </div>
                                <div class="month-input">
                                    <span class="tit">1개월 당</span>
                                    <div class="won">
                                        <input class="w60" type="text" />
                                        <span class="txt">원</span>
                                    </div>
                                </div>
                            </div>
                            <div class="sub-box w380">
                                <div class="com-radio">
                                    <input id="radio-2-2" name="radio-2" type="radio" />
                                    <label for="radio-2-2">개월별 차등금액</label>
                                </div>
                                <div class="month-table">
                                    <table>
                                        <colgroup>
                                            <col style="width: 100px" />
                                            <col style="width: 160px" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>개월</th>
                                                <th>금액</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>
                                                    <input class="w100" type="text" />
                                                    <small>원</small>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>
                                                    <input class="w100" type="text" />
                                                    <small>원</small>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>
                                                    <input class="w100" type="text" />
                                                    <small>원</small>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <button class="com-btn">+ 추가</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">사용여부</span>
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input id="radio-3-1" name="radio-3" type="radio" />
                                <label for="radio-3-1">사용중</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-3-2" name="radio-3" type="radio" />
                                <label for="radio-3-2">미사용</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="locker-list-content">
            <ul class="list">
                <li>
                    <span class="ic">사용중</span>
                    <span class="loca">복도앞 락커</span>
                    <span class="num">공통 / 1-100</span>
                    <span class="info">개월별 차등금액</span>
                </li>
                <li>
                    <span class="ic red">미사용</span>
                    <span class="loca">복도앞 락커</span>
                    <span class="num">공통 / 1-100</span>
                    <span class="info">개월별 차등금액</span>
                </li>
            </ul>
        </div>

        <div class="com-table-wrap">
            <div class="com-card-input half-type full">
                <div class="left-box full">
                    <span class="top-title">
                        이용권 결제 시
                        <small>이용권 결제 시, 결제 수단별 적립, 마일리지를 설정합니다.</small>
                    </span>
                    <div class="line">
                        <span class="tit">카드</span>
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input id="radio-1-1" checked name="radio-1" type="radio" />
                                <label for="radio-1-1">사용안함</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-1-2" name="radio-1" type="radio" />
                                <label for="radio-1-2">최소</label>
                            </div>
                            <input class="w80 center" type="text" />
                            <span class="txt">% 에서 최대</span>
                            <input class="w80 center" type="text" />
                            <span class="txt">% 까지 마일리지를 적립합니다.</span>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">현금</span>
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input id="radio-2-1" checked name="radio-2" type="radio" />
                                <label for="radio-2-1">사용안함</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-2-2" name="radio-2" type="radio" />
                                <label for="radio-2-2">최소</label>
                            </div>
                            <input class="w80 center" type="text" />
                            <span class="txt">% 에서 최대</span>
                            <input class="w80 center" type="text" />
                            <span class="txt">% 까지 마일리지를 적립합니다.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p class="sub-title small">
            강사가 회원과의 수업을 사전 예약 후 수업하지 않고, 월말정산 및 급여계산 전에 일괄적으로 등록·정산하는 것을
            방지하기 위한 기능입니다. 따라서 이미 수강한 수업의 정산을 위해, 수업 후 수업스케줄 등록을 언제까지 입력
            가능하게 할 것인지 강사 수업예약 메뉴를 통해 설정할 수 있습니다. 강사가 제한시간 이내에 예약하지 않은 경우,
            이미 지난 수업에 대한 예약은 불가능합니다.
            <span class="red">설정하지 않을 경우 어떠한 제한도 받지 않습니다.</span>
        </p>

        <div class="com-table-wrap">
            <div class="com-card-input half-type full">
                <div class="left-box full">
                    <span class="top-title">
                        예약 가능 시간
                        <small>회원이 시작시간으로부터 얼마 전까지 예약이 가능한지 설정합니다.</small>
                    </span>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w120">
                                <strong class="blue">개인 / OT</strong>
                                는 시작시간
                            </span>
                            <select-form :select-data="['선택']" class="w180"></select-form>
                            <span class="txt">일</span>
                            <select-form :select-data="['선택']" class="w180"></select-form>
                            <span class="txt">시간</span>
                            <select-form :select-data="['선택']" class="w180"></select-form>
                            <span class="txt">
                                분 전까지
                                <span class="red">예약</span>
                                이 가능합니다.
                            </span>
                        </div>
                    </div>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w120">
                                <strong class="blue">그룹</strong>
                                은 시작시간
                            </span>
                            <select-form :select-data="['선택']" class="w180"></select-form>
                            <span class="txt">일</span>
                            <select-form :select-data="['선택']" class="w180"></select-form>
                            <span class="txt">시간</span>
                            <select-form :select-data="['선택']" class="w180"></select-form>
                            <span class="txt">
                                분 전까지
                                <span class="red">예약</span>
                                이 가능합니다.
                            </span>
                        </div>
                    </div>
                    <div class="line">
                        <div class="input-cnt">
                            <span class="txt w120">
                                <strong class="blue">쿠폰</strong>
                                은 시작시간
                            </span>
                            <select-form :select-data="['선택']" class="w180"></select-form>
                            <span class="txt">일</span>
                            <select-form :select-data="['선택']" class="w180"></select-form>
                            <span class="txt">시간</span>
                            <select-form :select-data="['선택']" class="w180"></select-form>
                            <span class="txt">
                                분 전까지
                                <span class="red">예약</span>
                                이 가능합니다.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="com-table-wrap">
            <div class="com-card-input half-type full">
                <div class="left-box full">
                    <span class="top-title">
                        레슨권만 가진 회원의 경우, 예약된 스케줄이 없어도 입장 가능하도록 처리 하시겠습니까?
                    </span>
                    <div class="line">
                        <span class="tit">
                            회원이 수업구분이 OT, 개인, 듀엣, 그룹, 쿠폰인 이용권만 가지고 있는 경우 센터 입장이
                            가능합니다.
                        </span>
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input id="radio-1-1" checked name="radio-1" type="radio" />
                                <label for="radio-1-1">
                                    당일에 예약된 내역이 없다면
                                    <span class="red">입장불가능</span>
                                    합니다.
                                </label>
                            </div>
                        </div>
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input id="radio-1-2" name="radio-1" type="radio" />
                                <label for="radio-1-2">
                                    당일에 예약된 내역이 없어도
                                    <span class="green">입장가능</span>
                                    합니다.
                                </label>
                            </div>
                        </div>
                    </div>
                    <span class="top-title">입장 후 자동 퇴실시간 적용</span>
                    <div class="line">
                        <span class="tit">
                            회원이 터치모니터를 통하여 출석 체크 후, 특정 시간 후 자동 퇴실 처리를 할 것인지 설정합니다.
                        </span>
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input id="radio-2-1" checked name="radio-2" type="radio" />
                                <label for="radio-2-1">1시간</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-2-2" name="radio-2" type="radio" />
                                <label for="radio-2-2">2시간</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-2-3" name="radio-2" type="radio" />
                                <label for="radio-2-3">3시간</label>
                            </div>
                        </div>
                    </div>
                    <span class="top-title">회원 입장 시, 관리자 화면에 확인창을 띄우시겠습니까?</span>
                    <div class="line">
                        <span class="tit">
                            회원이 터치모니터를 통하여 출석 체크 시, 회원님의 정보를 관리자 화면에 보여줍니다.
                        </span>
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input id="radio-3-1" checked name="radio-3" type="radio" />
                                <label for="radio-3-1">예</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-3-2" name="radio-3" type="radio" />
                                <label for="radio-3-2">아니오</label>
                            </div>
                        </div>
                    </div>
                    <span class="top-title">
                        터치화면에 센터 이미지를 등록하시겠습니까? (최대 5개)
                        <span class="right-txt blue">* 용량 제한 : 10MB 이하 / 권장사이즈 : 1130*1200 px 이상</span>
                    </span>
                    <div class="line">
                        <span class="tit">회원번호를 입력하는 터치패드 화면에서 센터 이미지를 보여줍니다.</span>
                        <div class="input-cnt">
                            <div class="com-file-single preview">
                                <!-- 첨부 완료시 -->
                                <span class="complete-img">
                                    <img alt="" src="/img/icons/@temp_file_img.png" />
                                    <button class="del-btn"><span class="blind">삭제하기</span></button>
                                </span>
                                <!-- //첨부 완료시 -->
                                <b-form-file id="file1" accept=".jpg" plain></b-form-file>
                                <label class="preview" for="file1"></label>
                                <label class="white-btn" for="file1">+ 추가</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 직원 선택 팝업 -->
        <div v-show="pop == 1" class="layer-pop">
            <div class="view-content">
                <div class="top-area">
                    <span class="title">핏투데이케어 - 강남점</span>
                    <span class="txt">클릭 시, 해당 계정으로 접속 전환됩니다.</span>
                    <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                </div>
                <div class="scroll-area com-scroll-y">
                    <ul class="select-photo-list">
                        <li>
                            <a href="#">
                                <img alt="" src="/img/temp/layer_select_photo.jpg" />
                                <span class="name">홍길동</span>
                                <span class="tel">010-9999-9999</span>
                                <span class="type">8강사</span>
                                <span class="detail">필라 - 오전 파트팀</span>
                            </a>
                        </li>
                    </ul>
                    <b-pagination
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                    ></b-pagination>
                </div>
            </div>
        </div>

        <!-- 체인점 등록 레이어 팝업 -->
        <div v-show="pop == 2" class="layer-pop square">
            <div class="view-content w655">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="title">체인점 등록</span>
                    <table class="com-table col-style-2">
                        <colgroup>
                            <col style="width: 160px" />
                            <col style="width: 390px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td>본점</td>
                                <td>
                                    <div class="com-input-txt">
                                        <input placeholder="센터명을 입력하세요" type="text" />
                                        <button class="com-btn">검색</button>
                                    </div>
                                    <ul class="select-info-list">
                                        <li>
                                            <span class="txt">
                                                케어필라테스 강남점
                                                <button class="del-btn"></button>
                                            </span>
                                        </li>
                                        <li>
                                            <span class="txt">
                                                케어필라테스 강남점
                                                <button class="del-btn"></button>
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>지점</td>
                                <td>
                                    <div class="com-input-txt">
                                        <input placeholder="센터명을 입력하세요" type="text" />
                                        <button class="com-btn">검색</button>
                                    </div>
                                    <ul class="select-info-list">
                                        <li>
                                            <span class="txt">
                                                케어필라테스 강남점
                                                <button class="del-btn"></button>
                                            </span>
                                        </li>
                                        <li>
                                            <span class="txt">
                                                케어필라테스 강남점
                                                <button class="del-btn"></button>
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>최고권한</td>
                                <td>
                                    <div class="com-input-txt">
                                        <input placeholder="센터명을 입력하세요" type="text" />
                                        <button class="com-btn">검색</button>
                                    </div>
                                    <ul class="select-info-list">
                                        <li>
                                            <span class="txt">
                                                케어필라테스 강남점
                                                <button class="del-btn"></button>
                                            </span>
                                        </li>
                                        <li>
                                            <span class="txt">
                                                케어필라테스 강남점
                                                <button class="del-btn"></button>
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn">
                        <button class="com-btn">취소</button>
                        <button class="com-btn blue">등록</button>
                        <button class="com-btn red">삭제</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 카테고리 설정 팝업 -->
        <div v-show="pop == 3" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">카테고리 설정</span>
                    <p class="sub-txt">
                        카테고리의 이름을 추가, 수정 및 삭제 할 수 있습니다.
                        <br />
                        카테고리 삭제 시, 이전에 작성된 해당 카테고리의 게시글은 카테고리가 없이 표시됩니다.
                    </p>
                    <div class="del-box">
                        <div class="input-cnt">
                            <div class="line">
                                <input type="text" />
                                <button class="com-btn">삭제</button>
                            </div>
                            <div class="line">
                                <input type="text" />
                                <button class="com-btn">삭제</button>
                            </div>
                        </div>
                        <div class="add-btn-cnt">
                            <div class="line">
                                <button class="com-btn">+추가</button>
                            </div>
                            <p class="txt">
                                <span class="imp">*</span>
                                최대 10개까지 추가 가능합니다.
                            </p>
                        </div>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="pop = 0">취소</button>
                        <button class="com-btn blue">저장</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 카테고리 이동 설정 팝업 -->
        <div v-show="pop == 31" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">카테고리 이동</span>
                    <p class="sub-txt">
                        선택한 이용권의 카테고리를 이동할 수 있습니다.
                        <br />
                        하나의 이용권이 중복으로 카테고리에 들어갈 수 있습니다.
                    </p>
                    <div class="check-design-box">
                        <div class="input-cnt">
                            <div class="line">
                                <input id="category-check-1-1" checked name="category-check-1" type="checkbox" />
                                <label for="category-check-1-1">여름할인권</label>
                            </div>
                            <div class="line">
                                <input id="category-check-1-2" name="category-check-1" type="checkbox" />
                                <label for="category-check-1-2">스피닝</label>
                            </div>
                            <div class="line">
                                <input id="category-check-1-3" name="category-check-1" type="checkbox" />
                                <label for="category-check-1-3">임산부그룹</label>
                            </div>
                        </div>
                        <p class="info-txt">카테고리를 2개 이상 선택할 수 있습니다.</p>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="pop = 0">취소</button>
                        <button class="com-btn blue">이동</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 센터 검색 팝업 -->
        <div v-show="pop == 4" class="layer-pop square-type">
            <div class="view-content">
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">센터 검색 결과</span>
                    <div class="top-search-area">
                        <div class="right">
                            <input class="w220" placeholder="센터명" type="text" />
                            <button class="com-btn">검색</button>
                        </div>
                    </div>
                    <table class="com-table">
                        <colgroup>
                            <col style="width: 70px" />
                            <col style="width: 120px" />
                            <col style="width: 160px" />
                            <col style="width: 160px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th>센터명</th>
                                <th>담당자명</th>
                                <th>담당자 연락처</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="com-radio">
                                        <input id="radio-pop-1" name="radio-pop" type="radio" />
                                        <label for="radio-pop-1"></label>
                                    </div>
                                </td>
                                <td>센터1</td>
                                <td>홍길동</td>
                                <td>1980-01-01</td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="com-radio">
                                        <input id="radio-pop-2" name="radio-pop" type="radio" />
                                        <label for="radio-pop-2"></label>
                                    </div>
                                </td>
                                <td>센터2</td>
                                <td>홍길동</td>
                                <td>1980-01-01</td>
                            </tr>
                            <tr>
                                <td colspan="100">등록된 내용이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                    <b-pagination
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                    ></b-pagination>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="pop = 0">취소</button>
                        <button class="com-btn blue">선택</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 회원 검색 결과 팝업 -->
        <div v-show="pop == 5" class="layer-pop square-type">
            <div class="view-content">
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">회원 검색 결과</span>
                    <div class="top-search-area">
                        <div class="right">
                            <input class="w220" placeholder="회원명" type="text" />
                            <button class="com-btn">검색</button>
                        </div>
                    </div>
                    <table class="com-table">
                        <colgroup>
                            <col style="width: 70px" />
                            <col style="width: 120px" />
                            <col style="width: 160px" />
                            <col style="width: 160px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th>회원명</th>
                                <th>연락처</th>
                                <th>생년월일</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="com-radio">
                                        <input id="radio-pop-1" name="radio-pop" type="radio" />
                                        <label for="radio-pop-1"></label>
                                    </div>
                                </td>
                                <td>홍길동</td>
                                <td>017-999-9999</td>
                                <td>1980-01-01</td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="com-radio">
                                        <input id="radio-pop-2" name="radio-pop" type="radio" />
                                        <label for="radio-pop-2"></label>
                                    </div>
                                </td>
                                <td>홍길동</td>
                                <td>017-999-9999</td>
                                <td>1980-01-01</td>
                            </tr>
                            <tr>
                                <td colspan="100">등록된 내용이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                    <b-pagination
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                    ></b-pagination>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="pop = 0">취소</button>
                        <button class="com-btn blue">선택</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 환불 신청 레이어 팝업 -->
        <div v-show="pop == 6" class="layer-pop square">
            <div class="view-content w1425">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <div class="input-info-box">
                        <span class="title">환불 신청</span>
                        <!-- 이용권 정보 -->
                        <div class="use-info-cnt">
                            <span class="title">이용권 정보</span>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">이름</span>
                                    <input class="w220" readonly type="text" />
                                </div>
                                <div class="input-wrap">
                                    <span class="tit">총 결제금액</span>
                                    <input class="w440" readonly type="text" />
                                </div>
                            </div>
                            <span class="title blue">[개인] 필라테스 10회</span>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">담당강사</span>
                                    <input class="w220" readonly type="text" />
                                </div>
                                <div class="input-wrap">
                                    <span class="tit">매출직원</span>
                                    <input class="w220" readonly type="text" />
                                </div>
                                <div class="input-wrap">
                                    <span class="tit">사용횟수</span>
                                    <input class="w220" readonly type="text" />
                                </div>
                            </div>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">유효기간</span>
                                    <div class="com-calendar-wrap">
                                        <single-calendar></single-calendar>
                                        <div class="com-dash"><span class="dash">~</span></div>
                                        <single-calendar></single-calendar>
                                    </div>
                                    <span class="txt red">※ 환불 시 이용권의 종료일자를 선택하세요.</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">
                                        사용금액
                                        <span class="imp">*</span>
                                        <div class="com-tooltip"><button class="icon"></button></div>
                                    </span>
                                    <input class="w220" type="text" />
                                    <span class="input-txt">원</span>
                                </div>
                                <div class="input-wrap">
                                    <span class="tit">
                                        환불금액
                                        <span class="imp">*</span>
                                        <div class="com-tooltip"><button class="icon"></button></div>
                                    </span>
                                    <input class="w220" type="text" />
                                    <span class="input-txt">원</span>
                                </div>
                            </div>
                        </div>
                        <!-- //이용권 정보 -->
                        <!-- 이용권 정보 -->
                        <div class="use-info-cnt">
                            <span class="title">이용권 정보</span>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">이름</span>
                                    <input class="w220" readonly type="text" />
                                </div>
                                <div class="input-wrap">
                                    <span class="tit">총 결제금액</span>
                                    <input class="w440" readonly type="text" />
                                </div>
                            </div>
                            <span class="title blue">[개인] 요가 10회</span>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">담당강사</span>
                                    <input class="w220" readonly type="text" />
                                </div>
                                <div class="input-wrap">
                                    <span class="tit">매출직원</span>
                                    <input class="w220" readonly type="text" />
                                </div>
                                <div class="input-wrap">
                                    <span class="tit">사용횟수</span>
                                    <input class="w220" readonly type="text" />
                                </div>
                            </div>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">유효기간</span>
                                    <div class="com-calendar-wrap">
                                        <single-calendar></single-calendar>
                                        <div class="com-dash"><span class="dash">~</span></div>
                                        <single-calendar></single-calendar>
                                    </div>
                                    <span class="txt red">※ 환불 시 이용권의 종료일자를 선택하세요.</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">
                                        사용금액
                                        <span class="imp">*</span>
                                        <div class="com-tooltip"><button class="icon"></button></div>
                                    </span>
                                    <input class="w220" type="text" />
                                    <span class="input-txt">원</span>
                                </div>
                                <div class="input-wrap">
                                    <span class="tit">
                                        환불금액
                                        <span class="imp">*</span>
                                        <div class="com-tooltip"><button class="icon"></button></div>
                                    </span>
                                    <input class="w220" type="text" />
                                    <span class="input-txt">원</span>
                                </div>
                            </div>
                        </div>
                        <!-- //이용권 정보 -->

                        <span class="bar-line"></span>
                        <span class="title">환불 정보</span>
                        <div class="line">
                            <div class="input-wrap">
                                <span class="tit">
                                    환불직원
                                    <span class="imp">*</span>
                                    <div class="com-tooltip"><button class="icon"></button></div>
                                </span>
                                <select-form :select-data="['선택']" class="w220"></select-form>
                            </div>
                            <div class="input-wrap">
                                <span class="tit">
                                    환불 신청일
                                    <span class="imp">*</span>
                                </span>
                                <single-calendar class="w220"></single-calendar>
                            </div>
                        </div>
                        <div class="line">
                            <div class="input-wrap">
                                <span class="tit">마일리지 차감</span>
                                <input class="w220" type="text" />
                                <span class="input-txt">원 차감됩니다.</span>
                            </div>
                        </div>
                        <div class="line">
                            <div class="input-wrap">
                                <span class="tit">
                                    환불수단
                                    <span class="imp">*</span>
                                </span>
                                <div class="sub">
                                    <div class="com-radio">
                                        <input id="radio-acc-1" checked name="radio-acc" type="radio" />
                                        <label for="radio-acc-1">현금</label>
                                    </div>
                                    <div class="com-radio">
                                        <input id="radio-acc-2" name="radio-acc" type="radio" />
                                        <label for="radio-acc-2">계좌이체</label>
                                    </div>
                                    <div class="com-radio">
                                        <input id="radio-acc-3" name="radio-acc" type="radio" />
                                        <label for="radio-acc-3">카드취소</label>
                                    </div>
                                </div>
                                <div class="sub">
                                    <input class="w220" placeholder="환불합계 금액" readonly type="text" />
                                    <input class="w220" placeholder="은행명 입력" type="text" />
                                    <input class="w220" placeholder="예금주 입력" type="text" />
                                    <input class="w220" placeholder="계좌번호 입력" type="text" />
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <div class="input-wrap w100p">
                                <span class="tit">환불사유 및 메모</span>
                                <div class="sub">
                                    <textarea placeholder="내용을 입력해주세요."></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="com-notice-list">
                        <ul class="list">
                            <li>※ 유효기간은 환불신청일까지로 종료되며 예약 및 입장이 불가합니다.</li>
                            <li>
                                ※ 최종 환불완료 처리는
                                <span class="blue">매출 > 환불관리</span>
                                에서 가능합니다.
                            </li>
                        </ul>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="pop = 0">취소</button>
                        <button class="com-btn blue">등록</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 마일리지 등록 팝업 -->
        <div v-show="pop == 7" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">마일리지 등록</span>
                    <p class="sub-txt">마일리지를 수기로 적립 또는 차감이 가능합니다.</p>
                    <ul class="form-list">
                        <li>
                            <span class="tit">회원명 :</span>
                            <span class="name">홍길동</span>
                        </li>
                        <li>
                            <span class="tit">결제수단 :</span>
                            <div class="com-radio">
                                <input id="radio-pop-1" checked name="radio-pop" type="radio" />
                                <label for="radio-pop-1">적립</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-pop-2" name="radio-pop" type="radio" />
                                <label for="radio-pop-2">차감</label>
                            </div>
                        </li>
                        <li>
                            <span class="tit">
                                <span class="imp">*</span>
                                금액 :
                            </span>
                            <input type="text" />
                            <span class="txt">원</span>
                        </li>
                        <li>
                            <span class="tit">
                                <span class="imp">*</span>
                                내용 :
                            </span>
                            <input class="w435" type="text" />
                        </li>
                    </ul>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="pop = 0">취소</button>
                        <button class="com-btn blue">등록</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 상담내용 수정 레이어 팝업 -->
        <div v-show="pop == 8" class="layer-pop square">
            <div class="view-content w1425">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="title">상담내용 수정</span>
                    <div class="com-form-box">
                        <div class="line">
                            <div class="sub">
                                <span class="tit">이름</span>
                                <input class="w220" readonly type="text" value="홍길동" />
                            </div>
                            <div class="sub">
                                <span class="tit">
                                    상담자
                                    <span class="imp">*</span>
                                </span>
                                <select-form :select-data="['선택']" class="w220"></select-form>
                            </div>
                            <div class="sub">
                                <span class="tit">상담일자</span>
                                <single-calendar class="w220"></single-calendar>
                            </div>
                            <div class="sub">
                                <span class="tit">
                                    상담유형
                                    <span class="imp">*</span>
                                </span>
                                <select-form :select-data="['선택']" class="w220"></select-form>
                                <button class="com-setting-btn"><span class="blind">설정</span></button>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">상담경로</span>
                            <div class="com-radio">
                                <input id="radio-f1-1" checked name="radio-f1" type="radio" />
                                <label for="radio-f1-1">전화</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-f1-2" name="radio-f1" type="radio" />
                                <label for="radio-f1-2">방문</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-f1-3" name="radio-f1" type="radio" />
                                <label for="radio-f1-3">메시지</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-f1-4" name="radio-f1" type="radio" />
                                <label for="radio-f1-4">기타</label>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">유입경로</span>
                            <div class="com-radio">
                                <input id="radio-f2-1" checked name="radio-f2" type="radio" />
                                <label for="radio-f1-1">전단지</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-f2-2" name="radio-f2" type="radio" />
                                <label for="radio-f2-2">SNS</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-f2-3" name="radio-f2" type="radio" />
                                <label for="radio-f2-3">블로그</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-f2-4" name="radio-f2" type="radio" />
                                <label for="radio-f2-4">홈페이지</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-f2-5" name="radio-f2" type="radio" />
                                <label for="radio-f2-5">지인소개</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-f2-6" name="radio-f2" type="radio" />
                                <label for="radio-f2-6">기타</label>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">메모</span>
                            <textarea placeholder="상담내용을 입력해주세요."></textarea>
                        </div>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="pop = 0">취소</button>
                        <button class="com-btn blue">수정</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 이미지 미리보기 팝업 -->
        <div v-show="pop == 9" class="layer-pop notice-pop">
            <div class="view-content">
                <div class="top-area">
                    <span class="title">2월 신규 가입 이벤트!</span>
                    <button class="close-btn" @click="pop = 0"></button>
                </div>
                <div class="view-area">
                    <img alt="" src="/img/temp/popup_1.png" />
                </div>
                <div class="bottom-area">
                    <a class="detail-link" href="#">자세히보기</a>
                    <div class="week-check">
                        <div class="com-check">
                            <input id="week-check-1" name="week-check" type="checkbox" />
                            <label for="week-check-1">일주일간 띄우지 않음</label>
                        </div>
                        <button class="close" @click="pop = 0">닫기</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 기간연장 팝업 -->
        <div v-show="pop == 10" class="layer-pop square-type">
            <div class="view-content w880">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">기간연장</span>
                    <table class="com-table left">
                        <colgroup>
                            <col style="width: 160px" />
                            <col style="width: 600px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>회원명</th>
                                <td>홍길동</td>
                            </tr>
                            <tr>
                                <th>이용권명</th>
                                <td>
                                    <span class="ico type-1">[개인]</span>
                                    <span class="ico type-2">[그룹]</span>
                                    <span class="ico type-3">[패키지]</span>
                                    <span class="ico type-4">[회원권]</span>
                                    <span class="ico type-5">[듀엣]</span>
                                    <span class="ico type-6">[OT]</span>
                                    필라테스 10회
                                </td>
                            </tr>
                            <tr>
                                <th>현재 유효기간</th>
                                <td>2020.01.01 ~ 2020.01.31</td>
                            </tr>
                            <tr>
                                <th>유형</th>
                                <td>
                                    <div class="line">
                                        <div class="com-radio">
                                            <input id="radio-pop-1" name="radio-pop" type="radio" />
                                            <label for="radio-pop-1">연기 (단순 기간 연기)</label>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <div class="com-radio">
                                            <input id="radio-pop-2" name="radio-pop" type="radio" />
                                            <label for="radio-pop-2">홀딩 (연장 기간동안 예약 및 입장 불가)</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    연장기간
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="line">
                                        <single-calendar></single-calendar>
                                    </div>
                                    <div class="line">
                                        <input class="center w60" type="text" />
                                        <span class="txt">일</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>변경 후 유효기간</th>
                                <td>
                                    <span class="red">2019.12.01 ~ 2019.12.31</span>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    등록자
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <select-form :select-data="['선택']" class="w120"></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th>연기 사유</th>
                                <td>
                                    <textarea class="full"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn">
                        <button class="com-btn red">삭제</button>
                        <button class="com-btn" @click="pop = 0">취소</button>
                        <button class="com-btn blue">수정</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 대여내역 팝업 -->
        <div v-show="pop == 11" class="layer-pop square-type">
            <div class="view-content w1070">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">
                        대여내역
                        <span class="info-txt">복도 뒤 락커 110번</span>
                    </span>
                    <table class="com-table">
                        <colgroup>
                            <col style="width: 120px" />
                            <col style="width: 180px" />
                            <col style="width: 225px" />
                            <col style="width: 270px" />
                            <col style="width: 180px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>회원명</th>
                                <th>결제일자</th>
                                <th>결제정보</th>
                                <th>유효기간</th>
                                <th>회수일자</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>홍길동</td>
                                <td>2019-12-23</td>
                                <td>1개월 15,000원</td>
                                <td>2019-12-25 ~ 2020-01-24</td>
                                <td>
                                    <button class="com-btn">회수</button>
                                </td>
                            </tr>
                            <tr>
                                <td>홍길동</td>
                                <td>2019-12-23</td>
                                <td>1개월 15,000원</td>
                                <td>2019-12-25 ~ 2020-01-24</td>
                                <td>2019-12-23</td>
                            </tr>
                            <tr>
                                <td colspan="100">등록된 내용이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                    <b-pagination
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                    ></b-pagination>
                </div>
            </div>
        </div>

        <!-- 기간연장 일괄등록 팝업 -->
        <div v-show="pop == 12" class="layer-pop square-type">
            <div class="view-content w655">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">
                        기간연장 일괄등록
                        <span class="info-txt">info-txt</span>
                    </span>
                    <p class="sub-txt">이용권별로 선택하여 해당 이용권을 가진 유효회원의 기간을 일괄연장 합니다.</p>
                    <table class="com-table left no-border">
                        <colgroup>
                            <col style="width: 135px" />
                            <col style="width: 465px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>이용권명</th>
                                <td>
                                    <select-form :select-data="['선택']" class="w355"></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th>유형</th>
                                <td>
                                    <div class="com-radio">
                                        <input id="radio-pop-2-1" name="radio-pop-2" type="radio" />
                                        <label for="radio-pop-2-1">연기 (단순 기간 연기)</label>
                                    </div>
                                    <div class="com-radio">
                                        <input id="radio-pop-2-2" name="radio-pop" type="radio" />
                                        <label for="radio-pop-2-2">홀딩 (연장 기간동안 예약 및 입장 불가)</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>연장기간</th>
                                <td>
                                    <div class="com-calendar-wrap">
                                        <single-calendar class="w150"></single-calendar>
                                        <div class="com-dash"><span class="dash">~</span></div>
                                        <single-calendar class="w150"></single-calendar>
                                    </div>
                                    <input class="center w30 ml5" type="text" />
                                    <span class="txt">일</span>
                                </td>
                            </tr>
                            <tr>
                                <th>등록자</th>
                                <td>
                                    <select-form :select-data="['선택']" class="w160"></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th class="vat">연기 사유</th>
                                <td>
                                    <textarea class="full"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="pop = 0">취소</button>
                        <button class="com-btn blue">저장</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 발신자 등록 팝업 -->
        <div v-show="pop == 13" class="layer-pop square-type">
            <div class="view-content w655">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">발신자 추가</span>
                    <table class="com-table left no-border">
                        <colgroup>
                            <col style="width: 100%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td>
                                    <span class="top-tit">발신자 이름</span>
                                    <input class="w100p" placeholder="이름을 입력해주세요" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span class="top-tit">발신번호</span>
                                    <input class="w100p" placeholder="발신번호를 입력해주세요" type="text" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="pop = 0">취소</button>
                        <button class="com-btn blue">등록요청</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 체인점 등록 레이어 팝업 -->
        <div v-show="pop == 14" class="layer-pop square">
            <div class="view-content w1425">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="title">급여변동내역</span>
                    <ul class="history-list">
                        <li>
                            <span class="day">2019-08-01 ~ 현재</span>
                            <div class="line">
                                <span class="txt">기본급</span>
                                <span class="detail">1,000,000 원</span>
                            </div>
                            <div class="line">
                                <span class="txt">인센티브</span>
                                <span class="detail">총 매출의 6%</span>
                            </div>
                            <div class="line">
                                <span class="txt">개인</span>
                                <span class="detail">
                                    횟수 별 퍼센트 - 80회 이하 30% / 90회 이하 40% / 90회 초과 50%
                                </span>
                            </div>
                            <div class="line">
                                <span class="txt">듀엣</span>
                                <span class="detail">고정금액 - 30,000 원</span>
                            </div>
                            <div class="line">
                                <span class="txt">OT</span>
                                <span class="detail">
                                    횟수 별 퍼센트 - 80회 이하 30% / 90회 이하 40% / 90회 초과 50%
                                </span>
                            </div>
                            <div class="line">
                                <span class="txt">그룹</span>
                                <span class="detail">
                                    인원별 2명 까지 20,000 원 / 4명 까지 25,000 원 / 4명 초과 30,000 원
                                </span>
                            </div>
                            <div class="line">
                                <span class="txt red">횟수 별 포함 급여 *</span>
                                <span class="detail">[개인] [듀엣]</span>
                            </div>
                            <button class="com-btn red">삭제</button>
                        </li>
                    </ul>
                    <b-pagination
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                    ></b-pagination>
                </div>
            </div>
        </div>

        <!-- 스케줄표 시간설정 팝업 -->
        <div v-show="pop == 15" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">스케줄표 시간설정</span>
                    <p class="sub-txt">스케줄표에 보이는 시간을 설정합니다.</p>
                    <div class="time-select-box">
                        <select-form :select-data="['00']"></select-form>
                        <span class="dot">:</span>
                        <select-form :select-data="['00']"></select-form>
                        <span class="dash">~</span>
                        <select-form :select-data="['00']"></select-form>
                        <span class="dot">:</span>
                        <select-form :select-data="['00']"></select-form>
                    </div>
                    <p class="notice-txt">[시 : 분] 단위 표시입니다.</p>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="pop = 0">취소</button>
                        <button class="com-btn blue">이동</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 정보확인 팝업 -->
        <div v-show="pop == 16" class="layer-pop square-type">
            <div class="view-content w480">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y info">
                    <span class="sub-title">정보확인</span>
                    <div class="info-btn-area">
                        <button>출결승인하기</button>
                        <button>예약확인</button>
                        <button>예약취소</button>
                        <button>회원정보보기</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 스케줄 예약 팝업 -->
        <div v-show="pop == 17" class="layer-pop square-type">
            <div class="view-content w880">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <div class="com-tab">
                        <button :class="{ on: layerTab == 1 }" @click="layerTab = 1">스케줄 예약</button>
                        <button :class="{ on: layerTab == 2 }" @click="layerTab = 2">일정등록</button>
                    </div>
                    <!-- 스케줄예약, 스케줄수정 -->
                    <div class="view-area">
                        <!-- v-show="layerTab == 1" -->
                        <table class="com-table left">
                            <colgroup>
                                <col style="width: 140px" />
                                <col style="width: 570px" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>
                                        강사명
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <select-form :select-data="['선택']" class="w120"></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        회원명
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <input placeholder="회원명을 검색하세요" type="text" />
                                        <button class="com-btn">검색</button>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        이용권명
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <select-form :select-data="['선택']" class="w480"></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        수업일자
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <single-calendar></single-calendar>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        수업시작시간
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <select-form :select-data="['선택']" class="w100"></select-form>
                                        <span class="dot">:</span>
                                        <select-form :select-data="['선택']" class="w100"></select-form>
                                        <select-form :select-data="['선택']" class="w100"></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>룸 선택</th>
                                    <td>
                                        <table class="time-table">
                                            <tbody>
                                                <tr>
                                                    <th>00:00 ~ 00:00</th>
                                                    <td>
                                                        <select-form :select-data="['선택']" class="w170"></select-form>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>00:00 ~ 00:00</th>
                                                    <td>
                                                        <select-form :select-data="['선택']" class="w170"></select-form>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>수업메모</th>
                                    <td>
                                        <textarea class="full"></textarea>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="reservationPop = false">취소</button>
                            <button class="com-btn blue">등록</button>
                        </div>
                    </div>
                    <!-- //스케줄예약, 스케줄수정 -->
                    <!-- 일정등록, 일정수정 -->
                    <div class="view-area">
                        <table class="com-table left">
                            <colgroup>
                                <col style="width: 140px" />
                                <col style="width: 570px" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>
                                        강사명
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <select-form :select-data="['선택']" class="w120"></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        반복
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <div class="com-radio">
                                            <input id="radio-r1-1" checked name="radio-r1" type="radio" />
                                            <label for="radio-r1-1">안함</label>
                                        </div>
                                        <div class="com-radio">
                                            <input id="radio-r1-2" name="radio-r1" type="radio" />
                                            <label for="radio-r1-2">매일</label>
                                        </div>
                                        <div class="com-radio">
                                            <input id="radio-r1-3" name="radio-r1" type="radio" />
                                            <label for="radio-r1-3">매주</label>
                                        </div>
                                        <div class="detail-check-line">
                                            <div class="com-check">
                                                <input id="check-r1-1" name="check-r1" type="checkbox" />
                                                <label for="check-r1-1">월</label>
                                            </div>
                                            <div class="com-check">
                                                <input id="check-r1-2" name="check-r1" type="checkbox" />
                                                <label for="check-r1-2">화</label>
                                            </div>
                                            <div class="com-check">
                                                <input id="check-r1-3" name="check-r1" type="checkbox" />
                                                <label for="check-r1-3">수</label>
                                            </div>
                                            <div class="com-check">
                                                <input id="check-r1-4" name="check-r1" type="checkbox" />
                                                <label for="check-r1-4">목</label>
                                            </div>
                                            <div class="com-check">
                                                <input id="check-r1-5" name="check-r1" type="checkbox" />
                                                <label for="check-r1-5">금</label>
                                            </div>
                                            <div class="com-check">
                                                <input id="check-r1-6" name="check-r1" type="checkbox" />
                                                <label for="check-r1-6">토</label>
                                            </div>
                                            <div class="com-check">
                                                <input id="check-r1-7" name="check-r1" type="checkbox" />
                                                <label for="check-r1-7">일</label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        일자
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <div class="com-calendar-wrap">
                                            <single-calendar></single-calendar>
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <single-calendar></single-calendar>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        시간
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <select-form :select-data="['선택']" class="w100"></select-form>
                                        <span class="dot">~</span>
                                        <select-form :select-data="['선택']" class="w100"></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        일정선택
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <select-form :select-data="['선택']" class="w400"></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>직접작성</th>
                                    <td>
                                        <textarea class="full"></textarea>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="notice-txt">
                            등록한 시간 동안에는 일정이 있는 것으로 간주하고 회원은 회원 예약 앱에서 [개인/OT] 를 예약할
                            수 있습니다.
                        </p>
                        <div class="btn-line">
                            <button class="com-btn">일정삭제</button>
                        </div>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="reservationPop = false">취소</button>
                            <button class="com-btn blue">등록</button>
                        </div>
                    </div>
                    <!-- //일정등록, 일정수정 -->
                </div>
            </div>
        </div>

        <!-- 출결승인 팝업 -->
        <div v-show="pop == 18" class="layer-pop square-type">
            <div class="view-content w650">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">출결승인</span>
                    <div class="attend-info-area">
                        <span class="top-user">
                            <strong>박지현</strong>
                            회원님
                        </span>
                        <div class="info-box">
                            <span class="time">2019-11-27 08:00</span>
                            <span class="txt">
                                <span class="red">결석처리</span>
                                되었습니다.
                            </span>
                            <span class="txt">
                                <span class="blue">출석처리</span>
                                되었습니다.
                            </span>
                            <div class="input-line">
                                <input class="w100p" placeholder="결석일 경우, 사유를 입력해주세요." type="text" />
                            </div>
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="attendPop = false">취소</button>
                        <button class="com-btn blue">확인</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 휴강하기 확인 팝업 -->
        <div v-show="pop == 19" class="layer-pop square-type">
            <div class="view-content w650">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">휴강하기</span>
                    <div class="top-group-info type-black">
                        <div class="line">
                            <span class="cnt">김윤경 6/6 (명)</span>
                            <span class="time">2019.11.27 08:20 ~ 09:10</span>
                        </div>
                        <div class="line">
                            <span class="info-txt">타워리포머 + 발레바</span>
                        </div>
                    </div>
                    <div class="cancel-info-txt">
                        <p><span class="red">회원님들에게 휴강에 대한 안내를 하셨습니까?</span></p>
                        <p>
                            해당 시간에 예약된 스케줄은 모두
                            <span class="red">취소</span>
                            됩니다.
                        </p>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="restPop = false">휴강취소</button>
                        <button class="com-btn blue" @click="restCompletePop = true">확인</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 휴강하기 완료 팝업 -->
        <div v-show="pop == 20" class="layer-pop square-type">
            <div class="view-content w650">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">휴강하기</span>
                    <div class="top-group-info type-black">
                        <div class="line">
                            <span class="cnt">김윤경 6/6 (명)</span>
                            <span class="time">2019.11.27 08:20 ~ 09:10</span>
                        </div>
                        <div class="line">
                            <span class="info-txt">타워리포머 + 발레바</span>
                        </div>
                    </div>
                    <div class="cancel-info-txt">
                        <p>
                            휴강 및 예약이
                            <span class="red">취소</span>
                            되었습니다.
                        </p>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="restCompletePop = false">취소</button>
                        <button
                            class="com-btn blue"
                            @click="
                                restPop = false;
                                restCompletePop = false;
                            "
                        >
                            확인
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 그룹 일괄 예약 팝업 -->
        <div v-show="pop == 21" class="layer-pop square-type">
            <div class="view-content w480">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y info">
                    <span class="sub-title">그룹 일괄예약</span>
                    <p class="info-txt">체크한 날짜에 일괄예약이 저장되었습니다.</p>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="infoPop = false">취소</button>
                        <button class="com-btn blue">확인</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 기간연장 팝업 -->
        <div v-show="pop == 22" class="layer-pop square-type">
            <div class="view-content w880">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <div class="com-tab">
                        <button :class="{ on: layerTab == 1 }" @click="layerTab = 1">기간연장</button>
                        <button :class="{ on: layerTab == 2 }" @click="layerTab = 2">연장내역</button>
                    </div>
                    <!-- 기간연장 -->
                    <div class="view-area">
                        <!--  v-show="layerTab == 2" -->
                        <table class="com-table left">
                            <colgroup>
                                <col style="width: 160px" />
                                <col style="width: 600px" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>회원명</th>
                                    <td>홍길동</td>
                                </tr>
                                <tr>
                                    <th>이용권명</th>
                                    <td>
                                        <span class="ico type-1">[개인]</span>
                                        <span class="ico type-2">[그룹]</span>
                                        <span class="ico type-3">[패키지]</span>
                                        <span class="ico type-4">[회원권]</span>
                                        <span class="ico type-5">[듀엣]</span>
                                        <span class="ico type-6">[OT]</span>
                                        필라테스 10회
                                    </td>
                                </tr>
                                <tr>
                                    <th>현재 유효기간</th>
                                    <td>2020.01.01 ~ 2020.01.31</td>
                                </tr>
                                <tr>
                                    <th>유형</th>
                                    <td>
                                        <div class="line">
                                            <div class="com-radio">
                                                <input id="radio-pop-1" name="radio-pop" type="radio" />
                                                <label for="radio-pop-1">연기 (단순 기간 연기)</label>
                                            </div>
                                        </div>
                                        <div class="line">
                                            <div class="com-radio">
                                                <input id="radio-pop-2" name="radio-pop" type="radio" />
                                                <label for="radio-pop-2">홀딩 (연장 기간동안 예약 및 입장 불가)</label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        연장기간
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <div class="line">
                                            <single-calendar></single-calendar>
                                        </div>
                                        <div class="line">
                                            <input class="center w60" type="text" />
                                            <span class="txt">일</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>변경 후 유효기간</th>
                                    <td>
                                        <span class="red">2019.12.01 ~ 2019.12.31</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        등록자
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <select-form :select-data="['선택']" class="w120"></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>연기 사유</th>
                                    <td>
                                        <textarea class="full"></textarea>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="periodPop = false">취소</button>
                            <button class="com-btn blue">등록</button>
                        </div>
                    </div>
                    <!-- //기간연장 -->
                    <!-- 연장내역 -->
                    <div class="view-area">
                        <div class="user-info-box">
                            <div class="line">
                                <span class="name">홍길동 회원</span>
                                <span class="first right">최초 유효기간 | 2020.01.01 ~ 2020.01.10</span>
                            </div>
                            <div class="line">
                                <span class="name">
                                    <span class="ico type-1">[개인]</span>
                                    <!--
                                    <span class="ico type-2">[그룹]</span>
                                    <span class="ico type-3">[패키지]</span>
                                    <span class="ico type-4">[회원권]</span>
                                    <span class="ico type-5">[듀엣]</span>
                                    <span class="ico type-6">[OT]</span>
                                    -->
                                    필라테스 10회
                                </span>
                                <span class="now right">현재 유효기간 | 2020.01.01 ~ 2020.01.30</span>
                            </div>
                            <div class="line">
                                <span class="cnt right">총 연장횟수 : 2회</span>
                            </div>
                        </div>
                        <table class="com-table">
                            <colgroup>
                                <col style="width: 90px" />
                                <col style="width: 150px" />
                                <col style="width: 150px" />
                                <col style="width: 150px" />
                                <col style="width: 150px" />
                                <col style="width: 80px" />
                                <col style="width: 80px" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>등록일</th>
                                    <th>연장기간</th>
                                    <th>변경 전 기간</th>
                                    <th>변경 후 기간</th>
                                    <th>연기사유</th>
                                    <th>유형</th>
                                    <th>관리</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        2020.01.20
                                        <br />
                                        13:00:32
                                    </td>
                                    <td>
                                        2020.01.20 ~
                                        <br />
                                        2020.01.30
                                        <div class="line">
                                            <span class="red">(10일)</span>
                                        </div>
                                    </td>
                                    <td>
                                        2020.01.10 ~
                                        <br />
                                        2020.01.20
                                    </td>
                                    <td>
                                        2020.01.10 ~
                                        <br />
                                        2020.01.20
                                    </td>
                                    <td>겨울휴가</td>
                                    <td>홀딩</td>
                                    <td>
                                        <div class="line">
                                            <button class="com-btn red">삭제</button>
                                        </div>
                                        <div class="line">
                                            <button class="com-btn">수정</button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="100">등록된 내용이 없습니다.</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="periodPop = false">취소</button>
                            <button class="com-btn blue">등록</button>
                        </div>
                    </div>
                    <!-- //연장내역 -->
                </div>
            </div>
        </div>

        <!-- 스케줄 예약 심플 팝업 -->
        <div v-show="pop == 23" class="layer-pop square-type">
            <div class="view-content w880">
                <button class="close" @click="pop = 0"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">스케줄 예약</span>
                    <table class="com-table left">
                        <colgroup>
                            <col style="width: 140px" />
                            <col style="width: 570px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    강사명
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <select-form :select-data="['선택']" class="w120"></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    수업일자
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <single-calendar></single-calendar>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    수업시작시간
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <select-form :select-data="['선택']" class="w100"></select-form>
                                    <span class="dot">:</span>
                                    <select-form :select-data="['선택']" class="w100"></select-form>
                                    <select-form :select-data="['선택']" class="w100"></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th>룸 예약</th>
                                <td>
                                    <table class="time-table">
                                        <tbody>
                                            <tr>
                                                <th>00:00 ~ 00:00</th>
                                                <td>
                                                    <select-form :select-data="['선택']" class="w170"></select-form>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>00:00 ~ 00:00</th>
                                                <td>
                                                    <select-form :select-data="['선택']" class="w170"></select-form>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <th>수업메모</th>
                                <td>
                                    <textarea class="full"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="reservationPop = false">취소</button>
                        <button class="com-btn blue">등록</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'home',
    props: {
        propsSample: {
            type: Number,
            default: 0,
            required: false,
            validator(value) {
                return value >= 0;
            },
        },
    },
    data() {
        return {
            selectOpen: false,
            pop: '',
            sample: 0.5,
            dataTest: '',
            accountPop: false,
            accountPop2: false,
            fields: [
                {
                    key: 'th1',
                    label: '등록일',
                    sortable: true,
                },
                {
                    key: 'th2',
                    label: '센터명',
                },
                {
                    key: 'th3',
                    label: '접속',
                },
                {
                    key: 'th4',
                    label: '업종',
                },
                {
                    key: 'th5',
                    label: '센터구분',
                },
                {
                    key: 'th6',
                    label: '담당자명',
                },
                {
                    key: 'th7',
                    label: '담당자 연락처',
                },
                {
                    key: 'th8',
                    label: '센터 전화번호',
                },
                {
                    key: 'th9',
                    label: '센터 주소',
                },
                {
                    key: 'th10',
                    label: '계약상태',
                },
            ],
            items: [
                {
                    th1: '2019-12-01',
                    th2: '제어핏 필라테스 잠실점',
                    th3: '직원보기',
                    th4: '필라테스',
                    th5: '본점',
                    th6: '김윤경',
                    th7: '010-1234-4567',
                    th8: '02-222-2222',
                    th9: '서울시 송파구 석촌동 1-2',
                    th10: '유효',
                },
                {
                    th1: '2019-11-01',
                    th2: '제어핏 필라테스 잠실점2',
                    th3: '직원보기',
                    th4: '필라테스',
                    th5: '본점',
                    th6: '김윤경',
                    th7: '010-1234-4567',
                    th8: '02-222-2222',
                    th9: '서울시 송파구 석촌동 1-2',
                    th10: '유효',
                },
                {
                    th1: '2019-11-01',
                    th2: '제어핏 필라테스 잠실점3',
                    th3: '직원보기',
                    th4: '필라테스',
                    th5: '본점',
                    th6: '김윤경',
                    th7: '010-1234-4567',
                    th8: '02-222-2222',
                    th9: '서울시 송파구 석촌동 1-2',
                    th10: '유효',
                },
                {
                    th1: '2019-11-01',
                    th2: '제어핏 필라테스 잠실점4',
                    th3: '직원보기',
                    th4: '필라테스',
                    th5: '본점',
                    th6: '김윤경',
                    th7: '010-1234-4567',
                    th8: '02-222-2222',
                    th9: '서울시 송파구 석촌동 1-2',
                    th10: '유효',
                },
                {
                    th1: '2019-11-01',
                    th2: '제어핏 필라테스 잠실점5',
                    th3: '직원보기',
                    th4: '필라테스',
                    th5: '본점',
                    th6: '김윤경',
                    th7: '010-1234-4567',
                    th8: '02-222-2222',
                    th9: '서울시 송파구 석촌동 1-2',
                    th10: '유효',
                },
            ],
        };
    },
    computed: {
        comSample() {
            return this.sample + this.sample;
        },
    },
    mounted() {
        this.$nextTick(() => {
            // 모든 화면이 렌더링된 후 실행합니다.
            this.test();
        });

        this.axios.get('/test_axios.json').then((response) => {
            this.dataTest = response.data;
        });
        /*
                  .catch((error) => {
                    console.log('error ', error);
                  });
                  */

        // console.log(this._.random(20));
    },
    methods: {
        test() {},
        outsideClick() {
            this.selectOpen = false;
        },
    },
};
</script>
<style lang="scss">
.line-gap {
    margin-bottom: 20px;
}
</style>
